{
  "Dashboard": {
    "Welcome": "Willkommen",
    "Greeting": "Guten Tag, {{ name }}.",
    "Properties": {
      "Title": "Immobilien",
      "Description": "Hier finden Sie alle Ihre Immobilien auf einen Blick."
    },
    "Buildings": {
      "Title": "Gebäude",
      "Description": "Hier finden Sie alle Ihre Gebäude auf einen Blick."
    },
    "Units": {
      "Title": "Einheiten",
      "Description": "Hier finden Sie alle Ihre Einheiten auf einen Blick."
    },
    "Widgets": {
      "WorkQueue": "Auftragswarteschlange",
      "FinancialPulse": "Finanzpuls",
      "MyDesk": "Mein Schreibtisch"
    },
    "MyDesk": {
      "Title": "Mein Schreibtisch",
      "MyTasks": "Meine offenen Aufgaben",
      "NoTasks": "Keine offenen Aufgaben",
      "NoDue": "ohne Termin",
      "FollowUps": "Nächste Wiedervorlagen",
      "NoFollowUps": "Keine Wiedervorlagen",
      "LatestEmails": "Neueste E-Mails",
      "LatestDocuments": "Neueste Dokumente"
    },
    "FinancialPulse": {
      "BankBalance": "Bankbestand",
      "MonthlySollstellung": "Monatliche Sollstellung",
      "OpenOwnerReceivables": "Offene Forderungen",
      "ReserveBalance": "Rücklagenbestand",
      "Title": "Finanzen"
    },
    "Form": {
      "Widgets": "Widgets"
    },
    "Settings": "Dashboard anpassen",
    "Title": "Dashboard",
    "WorkQueue": {
      "DraftBookings": "Buchungen im Entwurf",
      "PendingInvites": "Offene Einladungen",
      "PendingPaymentApprovals": "Zahlungen zur Freigabe",
      "Title": "Arbeitsvorrat",
      "UnmatchedBankTransactions": "Unzugeordnete Bankumsätze"
    }
  },
  "Page": {
    "Units": {
      "Breadcrumb": "Meine Einheiten",
      "Title": "Ihre {{ unitCount }} Einheiten in {{ propertyCount }} Objekten"
    },
    "Property": {
      "Breadcrumb": "Objekt"
    },
    "Channels": {
      "Breadcrumb": "Kanäle",
      "Title": "Neuigkeiten Ihrer <b>Gemeinschaft</b>",
      "Subtitle": "Beiträge erstellt die Verwaltung — Sie können kommentieren und reagieren."
    },
    "Documents": {
      "Breadcrumb": "Dokumente",
      "Title": "Ihre <b>Unterlagen</b>"
    },
    "Profile": {
      "Data privacy": {
        "Notice": "Einwilligung zur Datenverarbeitung erteilt am <b>{{date}}</b> Ihre Daten werden ausschließlich zur Verwaltung Ihrer Einheiten verarbeitet (Art. 6 Abs. 1 lit. b DSGVO).",
        "Request": "Datenauskunft anfordern",
        "Recall": "Einwilligung widerrufen"
      }
    }
  },
  "Language Picker": {
    "Label": "Sprache"
  },
  "Navigation": {
    "Start": "Start",
    "Dashboard": "Dashboard",
    "Properties": "Objekte",
    "Buildings": "Gebäude",
    "Units": "Einheiten",
    "Documents": "Dokumente",
    "Profile": "Profil",
    "Contacts": "Kontakte",
    "Branches": "Filialen",
    "Journal": "Journal",
    "Channels": "Kanäle",
    "Accounts": "Konten",
    "FiscalYears": "Jahreszyklus",
    "DistributionKeys": "Verteilerschlüssel",
    "Webhooks": "Webhooks",
    "Notifications": "Benachrichtigungen",
    "Permissions": "Berechtigungen",
    "Sollstellung": "Sollstellung",
    "Settings": "Einstellungen",
    "EmailIntelligence": "E-Mail-Intelligenz",
    "Emails": "E-Mails",
    "Tasks": "Aufgaben",
    "Mailboxes": "Postfächer",
    "DriveImports": "Drive-Importe",
    "FollowUps": "Wiedervorlagen",
    "Outbox": "Postausgang",
    "AdministratorsOnly": "Dieser Bereich ist Administratoren vorbehalten",
    "Contractors": "Dienstleister",
    "AgentConfiguration": "KI-Agent",
    "MyStyle": "Mein KI-Stil",
    "AgentRules": "KI-Regeln",
    "Accounting": "Buchhaltung",
    "Administration": "Administration",
    "AnnualStatements": "Jahresabrechnungen",
    "BankConnections": "Bankverbindungen",
    "BankTransactions": "Bankumsätze",
    "Banking": "Banking",
    "BudgetPlans": "Wirtschaftspläne",
    "Communication": "Kommunikation",
    "Cycle": "Jahreszyklus",
    "Inspections": "Begehungen",
    "MasterData": "Stammdaten",
    "Matches": "Zuordnungen",
    "MatchingRules": "Zuordnungsregeln",
    "Meetings": "Versammlungen",
    "PaymentBatches": "Zahlläufe",
    "PlatformUsers": "Plattform-Benutzer",
    "SepaMandates": "SEPA-Mandate",
    "TenantDomains": "Domains",
    "TenantWorkflows": "Workflows",
    "DmsGovernance": "DMS-Governance"
  },
  "List": {
    "Pagination": {
      "Items per page": "Elemente pro Seite",
      "Page from total": "Seite {{ page }} von {{ total }}"
    },
    "Header": {
      "Selected": "{{ selected }} von {{ total }} ausgewählt",
      "Entries": "Einträge"
    },
    "Filter": {
      "Clear all": "Alle löschen",
      "Open": "Filter öffnen",
      "From": "Von",
      "To": "Bis"
    },
    "Actions": {
      "Label": "Aktionen",
      "View": "Ansehen",
      "Delete": "Löschen",
      "Edit": "Bearbeiten"
    },
    "NotFound": "Keine Einträge gefunden.",
    "Type": {
      "Grid": "Kacheln",
      "Rows": "Zeilen",
      "Table": "Tabelle"
    },
    "ModifiedAt": "Zuletzt geändert"
  },
  "Property": {
    "Property": "Objekt",
    "Properties": "Objekte",
    "Search for properties": "Suche nach Objekten",
    "No properties found": "Keine Objekte gefunden",
    "Contractors": {
      "Title": "Dienstleister",
      "Trade": "Gewerk",
      "Contractor": "Dienstleister",
      "Period": "Zeitraum",
      "Contract": "Vertrag",
      "Empty": "Noch keine Dienstleister zugeordnet",
      "Add": "Zuordnung"
    },
    "Form": {
      "AgentNotesSection": "KI-Hinweise zum Objekt (Runbook)",
      "AgentNotesHint": "Besonderheiten dieses Objekts, die die KI bei jeder zugeordneten E-Mail beachtet — Freigabegrenzen, Beirats-Eigenheiten, abweichende Stammfirmen, Ton. Eine Regel pro Zeile.",
      "AgentNotes": "KI-Hinweise",
      "AgentNotesPlaceholder": "z.B.: Beirat Herr Kohl wird von Denise A. geduzt. Aufzug ausschließlich über Schindler. Keine Beauftragungen ohne Beirats-CC.",
      "Address": "Adresse",
      "Figures": "Kennzahlen",
      "MasterData": "Stammdaten",
      "TotalArea": "Gesamtfläche (m²)",
      "City": "Stadt",
      "HouseNumber": "Hausnummer",
      "Name": "Name",
      "Street": "Straße",
      "TotalShares": "Miteigentumsanteile gesamt",
      "Number": "Objektnummer",
      "Type": "Typ",
      "ZipCode": "PLZ",
      "CreateTitle": "Objekt anlegen",
      "EditTitle": "Objekt bearbeiten",
      "Subtitle": "Stammdaten des Objekts — Adresse und Typ.",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Number": "Eindeutige Nummer des Objekts — der nächste freie Vorschlag wird automatisch geladen, gelöschte Nummern werden nie wiederverwendet.",
        "Name": "Bezeichnung des Objekts, z. B. „WEG Musterstraße 12“.",
        "Type": "Art des Objekts: WEG, Mietverwaltung oder Sondereigentumsverwaltung.",
        "Street": "Straße des Objekts.",
        "HouseNumber": "Hausnummer des Objekts.",
        "ZipCode": "Postleitzahl des Objekts.",
        "City": "Ort des Objekts.",
        "TotalShares": "Gesamte Miteigentumsanteile des Objekts — ganze Zahl, üblich sind 1.000 oder 10.000.",
        "TotalArea": "Gesamtfläche des Objekts in m².",
        "AgentNotes": "Besonderheiten des Objekts für den KI-Assistenten — fließen als Kontext in Antworten ein."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Objekt anlegen",
          "Description": "Dieses Formular legt ein neues Objekt an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Bezeichnung des Objekts, z. B. „WEG Musterstraße 12“. Pflichtfeld."
        },
        "Type": {
          "Title": "Typ",
          "Description": "Art des Objekts: WEG, Mietverwaltung oder Sondereigentumsverwaltung."
        },
        "Street": {
          "Title": "Straße",
          "Description": "Straße des Objekts. Pflichtfeld."
        },
        "HouseNumber": {
          "Title": "Hausnummer",
          "Description": "Hausnummer des Objekts. Pflichtfeld."
        },
        "ZipCode": {
          "Title": "PLZ",
          "Description": "Postleitzahl des Objekts. Pflichtfeld."
        },
        "City": {
          "Title": "Ort",
          "Description": "Ort des Objekts. Pflichtfeld."
        },
        "TotalShares": {
          "Title": "Miteigentumsanteile",
          "Description": "Gesamte MEA des Objekts als ganze Zahl — üblich sind 1.000 oder 10.000."
        },
        "TotalArea": {
          "Title": "Gesamtfläche",
          "Description": "Gesamtfläche des Objekts in m²."
        },
        "AgentNotes": {
          "Title": "Hinweise für den Assistenten",
          "Description": "Besonderheiten des Objekts für den KI-Assistenten — fließen als Kontext in Antworten ein."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt das Objekt an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      },
      "BackToList": "Zur Objektliste"
    },
    "Actions": {
      "Create": "Objekt anlegen",
      "ProvisionChart": "Kontenrahmen anlegen"
    },
    "List": {
      "TotalShares": "MEA gesamt",
      "Type": "Art",
      "Units": "Einheiten",
      "City": "Stadt",
      "Filter": {
        "BranchIds": "Niederlassungen",
        "City": "Stadt",
        "Filter": "Suche",
        "Name": "Name",
        "Types": "Typen"
      },
      "Name": "Name",
      "Number": "Nummer",
      "Title": "Objekte",
      "Subtitle": "Alle verwalteten Objekte — WEG, SEV und Mietverwaltung."
    },
    "Toasts": {
      "ChartProvisioned": "Kontenrahmen angelegt.",
      "Created": "Objekt angelegt.",
      "Updated": "Objekt gespeichert."
    },
    "Types": {
      "Rental": "Mietverwaltung",
      "Sev": "SEV",
      "Weg": "WEG"
    },
    "Detail": {
      "Objekt": "Objekt",
      "Tabs": {
        "Overview": "Übersicht",
        "Structure": "Struktur",
        "Contractors": "Dienstleister",
        "Documents": "Dokumente",
        "Emails": "Korrespondenz",
        "Tasks": "Aufgaben",
        "Activities": "Aktivitäten",
        "Records": "eAkte"
      },
      "WithoutBuilding": "Ohne Gebäude",
      "NoUnits": "Noch keine Einheiten angelegt.",
      "UnitPage": "Detailseite",
      "History": "Beteiligten-Historie · zeitliche Zuordnung",
      "Active": "aktiv",
      "Ended": "beendet",
      "NoHistory": "Keine Beteiligungen hinterlegt.",
      "AddUnit": "Einheit anlegen",
      "Columns": {
        "Number": "Nr.",
        "Name": "Bezeichnung",
        "Owner": "Eigentümer",
        "Share": "MEA"
      },
      "NoUnitsInBuilding": "Keine Einheiten",
      "NoActivities": "Keine Aktivitäten"
    },
    "Records": {
      "Summary": "{{fulfilled}} erfüllt · {{missing}} fehlen",
      "PropertyLevel": "Objektebene",
      "Missing": "fehlt",
      "NoRules": "Kein Aktenplan hinterlegt — Regeln definieren, welche Dokumenttypen je Objekt/Einheit vorliegen müssen."
    }
  },
  "User": {
    "User": "Benutzer",
    "Users": "Benutzer",
    "Search for users": "Suche nach Benutzern",
    "Roles": {
      "Super Administrator": "Super Administrator",
      "User": "Benutzer",
      "Contact": "Kontakt"
    },
    "List": {
      "Filter": {
        "Filter": "Filter",
        "Email": "E-Mail",
        "Roles": "Rollen"
      }
    },
    "No users found": "Keine Benutzer gefunden",
    "Search for users or create new ones": "Benutzer suchen",
    "Colleague": "Mitarbeiter",
    "Search for colleagues": "Nach Mitarbeitern suchen"
  },
  "Error": {
    "Not Found": {
      "Title": "Seite nicht gefunden",
      "Description": "Die Seite, die Sie suchen, existiert nicht oder wurde verschoben.",
      "Back to Dashboard": "Zurück zum Dashboard"
    }
  },
  "Form": {
    "Fields": {
      "Searcher": {
        "No entities found": "Keine {{ entity }} gefunden",
        "Search for entities": "Suche nach {{ entity }}",
        "Create new entity": "Neue {{ entity }} erstellen",
        "Errors": {
          "Required": "Bitte einen Eintrag wählen."
        }
      },
      "Errors": {
        "Required": "{{ field }} ist erforderlich",
        "Unknown": "Unbekannter Fehler für {{ field }}",
        "Email": "{{ field }} muss eine gültige E-Mail-Adresse sein",
        "Min": "{{ field }} muss größer oder gleich {{ min }} sein",
        "Max": "{{ field }} muss kleiner oder gleich {{ max }} sein",
        "MinLength": "{{ field }} muss mindestens {{ minLength }} Zeichen lang sein",
        "MaxLength": "{{ field }} muss höchstens {{ maxLength }} Zeichen lang sein",
        "Pattern": "{{ field }} hat kein gültiges Format",
        "DateRange": "{{ field }} muss danach liegen",
        "NumberTaken": "{{ field }} ist bereits vergeben"
      },
      "Password": {
        "At least 8 characters": "Mindestens 8 Zeichen",
        "At least one letter": "Mindestens ein Buchstabe",
        "At least one number": "Mindestens eine Zahl",
        "At least one special character": "Mindestens ein Sonderzeichen",
        "MaxLength": {
          "End": "Zeichen lang sein.",
          "Start": "Das Passwort darf höchstens"
        },
        "MinLength": {
          "End": "Zeichen lang sein.",
          "Start": "Das Passwort muss mindestens"
        },
        "Please mind the requirements": "Bitte beachten Sie die Anforderungen",
        "Required": {
          "End": "ist erforderlich.",
          "Start": "Das Feld"
        },
        "The distinct": "Die Passwörter müssen sich unterscheiden.",
        "The match": "Die Passwörter müssen übereinstimmen.",
        "The requirements": "Die Anforderungen sind nicht erfüllt."
      },
      "please provide displayName": "Bitte einen Anzeigenamen angeben"
    },
    "Actions": {
      "Submit": "Absenden",
      "Save": "Speichern",
      "Cancel": "Abbrechen",
      "Reset": "Zurücksetzen"
    },
    "Wysiwyg": {
      "Body": "Body",
      "Heading1": "H1",
      "Heading2": "H2",
      "Heading3": "H3",
      "Heading4": "H4",
      "Heading5": "H5",
      "Heading6": "H6",
      "StyleNone": "Default",
      "StylePrimary": "Primary",
      "StyleSecondary": "Secondary",
      "AlignCenter": "Zentriert",
      "AlignLeft": "Linksbündig",
      "AlignRight": "Rechtsbündig",
      "AlignmentLabel": "Ausrichtung",
      "ApplyLink": "Link setzen",
      "BlockFormatLabel": "Absatzformat",
      "Bold": "Fett",
      "BulletList": "Aufzählung",
      "ClearFormatting": "Formatierung entfernen",
      "Italic": "Kursiv",
      "Link": "Link",
      "LinkPlaceholder": "https://…",
      "ListsLabel": "Listen",
      "MarksLabel": "Auszeichnung",
      "NumberedList": "Nummerierte Liste",
      "Redo": "Wiederholen",
      "RemoveLink": "Link entfernen",
      "StyleLabel": "Stil",
      "ToolbarLabel": "Editor-Werkzeuge",
      "Underline": "Unterstrichen",
      "Undo": "Rückgängig"
    },
    "Errors": {
      "Summary": "Das Formular enthält noch {{ count }} Fehler:",
      "Validation": "Bitte die markierten Felder korrigieren.",
      "BadRequest": "Die Eingaben sind ungültig.",
      "EmailAddressInvalid": "Die E-Mail-Adresse ist ungültig.",
      "EventAttendeeAlreadyAttending": "Bereits angemeldet.",
      "NewsletterRecipientAlreadyRegistered": "Bereits registriert.",
      "ProductAttributesUploadDuplicate": "Doppelter Upload.",
      "ProfileCompletionCompanyCannotBeAssigned": "Firma kann nicht zugewiesen werden.",
      "ProfileCompletionCompanyDetailsMustNotBeEmpty": "Firmendaten dürfen nicht leer sein.",
      "ProfileCompletionCompanyMustBeProvided": "Bitte eine Firma angeben.",
      "ResourceNotFound": "Die Ressource wurde nicht gefunden.",
      "TagNameMustBeUnique": "Der Name ist bereits vergeben.",
      "TeamNameMustBeUnique": "Der Name ist bereits vergeben.",
      "TooManyEventAttendees": "Zu viele Teilnehmer.",
      "TooManyInterestsForNewsletterRecipient": "Zu viele Interessen.",
      "Unknown": "Ein unbekannter Fehler ist aufgetreten.",
      "UserProfileAlreadyCompleted": "Profil bereits vollständig."
    }
  },
  "Thread": {
    "Action": {
      "React": "Reagieren",
      "Reply": "Antworten",
      "Collapse": "Einklappen",
      "Expand": "Ausklappen",
      "Cancel": "Abbrechen",
      "Send": "Senden"
    },
    "Reply": "Antwort",
    "Replies": "Antworten",
    "Reply placeholder": "Was denkst du darüber?",
    "Reply success": "Deine Antwort wurde erfolgreich gesendet.",
    "Message": {
      "Reaction": {
        "Like": "Geffält mir",
        "Dislike": "Gefällt mir nicht"
      }
    }
  },
  "Email": {
    "Emails": "E-Mails",
    "List": {
      "ReceivedAt": "Empfangen",
      "From": "Von",
      "Subject": "Betreff",
      "Preview": "Vorschau",
      "Category": "Kategorie",
      "Property": "Liegenschaft",
      "NeedsReply": "Antwort nötig",
      "Filter": {
        "Filter": "Suche",
        "OnlyNeedsReply": "Nur Antwort nötig"
      },
      "AiStatus": "KI",
      "Title": "E-Mails",
      "PageTitle": "E-Mails",
      "PageSubtitle": "Alle E-Mails über alle Postfächer."
    },
    "Categories": {
      "Schadensmeldung": "Schadensmeldung",
      "Mieteranfrage": "Mieteranfrage",
      "Eigentuemeranfrage": "Eigentümeranfrage",
      "Rechnung": "Rechnung",
      "Kuendigung": "Kündigung",
      "Beschwerde": "Beschwerde",
      "Handwerker": "Handwerker",
      "Behoerde": "Behörde",
      "Versicherung": "Versicherung",
      "Termin": "Termin",
      "Sonstiges": "Sonstiges",
      "inquiry": "Anfrage",
      "order": "Auftrag",
      "invoice": "Rechnung",
      "complaint": "Beschwerde",
      "appointment": "Termin",
      "application": "Bewerbung",
      "newsletter": "Newsletter",
      "notification": "Benachrichtigung",
      "outOfOffice": "Abwesenheitsnotiz",
      "spam": "Spam",
      "other": "Sonstiges",
      "Unknown": "Unbekannt",
      "Inquiry": "Allgemeine Anfrage",
      "Order": "Auftrag",
      "Invoice": "Rechnung",
      "Complaint": "Beschwerde",
      "Appointment": "Termin",
      "Application": "Bewerbung",
      "Newsletter": "Newsletter",
      "Notification": "Benachrichtigung",
      "OutOfOffice": "Abwesenheitsnotiz",
      "Spam": "Spam",
      "Other": "Sonstiges",
      "Resolution": "Beschluss & Versammlung",
      "Contract": "Vertrag",
      "DamageReport": "Schadensmeldung",
      "Legal": "Rechtliches",
      "Insurance": "Versicherung",
      "Statement": "Abrechnung",
      "Contractor": "Handwerker",
      "TenantInquiry": "Mieteranfrage",
      "OwnerInquiry": "Eigentümeranfrage",
      "Authority": "Behörde",
      "Termination": "Kündigung",
      "Bank": "Bank & Zahlungsverkehr",
      "Maintenance": "Wartung & Prüfung",
      "MeterReading": "Zählerstand & Ablesung"
    },
    "OcrStatuses": {
      "Pending": "OCR ausstehend",
      "PendingFallback": "OCR Fallback",
      "Completed": "OCR abgeschlossen",
      "Failed": "OCR fehlgeschlagen",
      "Skipped": "kein OCR"
    },
    "Detail": {
      "Back": "Zurück",
      "Attachments": "Anhänge",
      "InlineAttachment": "Eingebettet",
      "ShowQuotedHistory": "Zitierten Verlauf anzeigen",
      "Analysis": "KI-Analyse",
      "Category": "Kategorie",
      "Draft": "Antwortentwurf",
      "AgentDraft": "Agenten-Entwurf",
      "QueuedToast": "In den Postausgang gelegt — Senden in 30 Sekunden",
      "SendingIn": "Wird gesendet in",
      "CancelSend": "Abbrechen",
      "CancelledToast": "Senden abgebrochen",
      "CancelTooLate": "Zu spät — die Antwort wurde bereits gesendet",
      "SendDraft": "Senden",
      "Sent": "Gesendet ✓",
      "ConfirmSend": "Antwort jetzt wirklich per E-Mail senden?",
      "SentToast": "Antwort gesendet — sie erscheint nach dem nächsten Sync im Verlauf",
      "SendForbidden": "Nur die zuständige Person dieses Postfachs darf senden",
      "SendFailed": "Senden fehlgeschlagen — bitte erneut versuchen",
      "Refine": "Anpassen",
      "Refining": "Überarbeitet …",
      "RefinePlaceholder": "Entwurf anpassen: z.B. kürzer, Termin Dienstag anbieten, förmlicher …",
      "CopyDraft": "Kopieren",
      "Sources": "Quellen",
      "NoAnalysis": "Noch keine Analyse vorhanden.",
      "RetryOcr": "Text neu extrahieren",
      "DraftTo": "An",
      "Tasks": "Aufgaben",
      "ToBoard": "Zum Aufgabenboard",
      "FollowUp": "Wiedervorlage",
      "FollowUpDate": "Datum",
      "FollowUpNote": "Notiz",
      "FollowUpSet": "Wiedervorlage setzen",
      "FollowUpClear": "Wiedervorlage entfernen",
      "Conversation": "Konversation",
      "Outgoing": "Gesendet",
      "OpenMessage": "Nachricht öffnen",
      "ReprocessAi": "Neu verarbeiten",
      "ProcessNow": "Jetzt verarbeiten",
      "NotProcessed": "Diese E-Mail wurde noch nicht von der KI verarbeitet.",
      "QuickSuggestionHint": "Schnellvorschlag aus der Analyse — ohne Quellenrecherche. Für einen recherchierten Entwurf mit Quellen den Agenten ausführen.",
      "AnsweredOn": "Beantwortet am",
      "OpenReply": "Antwort öffnen",
      "CurrentEmail": "Diese E-Mail",
      "DraftPending": "Noch kein Agenten-Entwurf. Der Agent recherchiert Quellen und formuliert einen fundierten Entwurf.",
      "Composing": "Der Agent recherchiert und formuliert gerade — das dauert einen Moment …",
      "ComposeNow": "Jetzt entwerfen",
      "ComposingButton": "Entwurf läuft …",
      "DraftedAt": "Entworfen am",
      "SourceCount": "Quellen",
      "TaskDialogTitle": "Aufgabe",
      "RelatedTasks": "Weitere offene Aufgaben zu diesem Objekt",
      "RelatedDocuments": "Aktuelle Dokumente zu diesem Objekt",
      "To": "An",
      "Cc": "Cc",
      "DraftPanelTitle": "KI-Antwortentwurf",
      "DraftCopied": "Entwurf mit Formatierung kopiert.",
      "NoContactFound": "Kein Kontakt zu dieser E-Mail-Adresse gefunden.",
      "Contact": "Kontakt",
      "Property": "Objekt",
      "ReplyReceivedOn": "Antwort erhalten am",
      "Assignment": {
        "None": "Keine Zuordnung",
        "Set": "Zuordnen",
        "Edit": "Zuordnung ändern",
        "Save": "Speichern",
        "Clear": "Zuordnung entfernen",
        "Property": "Objekt",
        "Unit": "Einheit",
        "Contact": "Kontakt"
      },
      "EmployeeProfile": {
        "Title": "Mitarbeiterprofil",
        "Roles": "Rollen",
        "LastLogin": "Letzte Anmeldung",
        "Write": "E-Mail schreiben",
        "Internal": "Intern"
      },
      "Assignee": "Zuständig",
      "Unassigned": "Niemand",
      "NeedsReplyOn": "Antwort nötig",
      "NeedsReplyOff": "Keine Antwort nötig",
      "NeedsReplyToggleHint": "Klicken zum Umschalten — die Korrektur trainiert die KI-Regeln mit.",
      "SuggestedTask": "Aufgaben-Vorschlag",
      "SuggestionDue": "Fällig",
      "ApproveTask": "Übernehmen",
      "DismissTask": "Verwerfen",
      "DeleteTask": "Aufgabe löschen",
      "FollowUpProposalHint": "Vorschlag aus der KI-Analyse — Frist:",
      "NoSourcesUsed": "Der Agent hat für diesen Entwurf keine Quellen verwendet.",
      "NoBody": "Diese E-Mail enthält keinen Textinhalt (z. B. reine Anhang-Mail).",
      "NoPropertyTitle": "Kein Objekt zugeordnet",
      "NoPropertyHint": "Der KI-Entwurf arbeitet ohne Objektkontext (keine Vorab-Recherche, keine Quellen-Stufen). Bitte die Zuordnung rechts prüfen und das Objekt setzen.",
      "DebugExport": "Export",
      "SignatureAppendedHint": "Signatur wird beim Senden und Kopieren automatisch angehängt.",
      "CreateContact": "Kontakt anlegen",
      "From": "Von",
      "Relations": "Zuordnung",
      "Tags": {
        "Answered": "Beantwortet",
        "NoActionNeeded": "Keine Aktion nötig",
        "DraftReady": "Entwurf bereit"
      },
      "AssignmentTitle": "Zuweisung",
      "CreateProperty": "Objekt anlegen",
      "CreateContractor": "Dienstleister anlegen",
      "CreateUnit": "Einheit anlegen",
      "AppliedRules": "Regeln angewandt:",
      "FeedbackThanks": "Danke — Regel lernt.",
      "KnownContact": "Kontakt öffnen",
      "InternalAddress": "Interne Adresse (Postfach oder Mitarbeiter)",
      "InternalMailbox": "Das ist eines unserer eigenen Postfächer — kein Kontakt und kein Mitarbeiterkonto."
    },
    "KeyFacts": {
      "Title": "Notierte Fakten",
      "Types": {
        "termin": "Termin",
        "frist": "Frist",
        "zusage": "Zusage",
        "betrag": "Betrag",
        "zaehlerstand": "Zählerstand",
        "kontaktdaten": "Kontaktdaten",
        "abstimmung": "Abstimmung",
        "sonstiges": "Hinweis"
      }
    },
    "Toasts": {
      "DraftCopied": "Entwurf in die Zwischenablage kopiert",
      "ReprocessTriggered": "Verarbeitung erneut gestartet",
      "FollowUpSet": "Wiedervorlage gesetzt",
      "FollowUpCleared": "Wiedervorlage entfernt",
      "DraftComposed": "Entwurf erstellt",
      "DraftFailed": "Entwurf fehlgeschlagen",
      "AssignmentSaved": "Zuordnung gespeichert — {{ count }} Dokument(e) übernommen",
      "AssignmentFailed": "Zuordnung konnte nicht gespeichert werden"
    },
    "AiStatuses": {
      "Pending": "Ausstehend",
      "Completed": "Abgeschlossen",
      "Failed": "Fehlgeschlagen",
      "Skipped": "Übersprungen"
    },
    "AttachmentPreview": {
      "NoPreview": "Für diesen Dateityp gibt es keine Vorschau.",
      "Loading": "Vorschau wird geladen …",
      "Download": "Herunterladen"
    },
    "Split": {
      "Outgoing": "Gesendet",
      "Search": "Suchen – Enter durchsucht alle Mails inkl. Anhänge",
      "Empty": "Keine E-Mails.",
      "OpenFull": "Vollansicht",
      "Loading": "Wird geladen …",
      "NoSelection": "E-Mail links auswählen",
      "Inbox": "Posteingang",
      "All": "Alle",
      "Tags": {
        "NeedsReply": "Antwort nötig",
        "DraftReady": "Entwurf bereit",
        "Answered": "Beantwortet",
        "FollowUp": "Wiedervorlage",
        "NoActionRequired": "Keine Aktion nötig",
        "AnalysisPending": "Analyse ausstehend"
      },
      "LoadingThread": "Weitere E-Mails der Konversation werden geladen …",
      "Mine": "Meine",
      "NewMessages": "Neue Nachrichten",
      "Outbox": "Postausgang"
    },
    "Outbox": {
      "Title": "Postausgang",
      "Empty": "Keine ausstehenden Sendungen",
      "Pending": "Wird gesendet",
      "Failed": "Fehlgeschlagen",
      "Dismiss": "Verwerfen",
      "Retry": "Erneut senden",
      "RetryQueued": "Erneut in den Postausgang gestellt",
      "RetryNotPossible": "Erneutes Senden nicht möglich — nur der zugewiesene Nutzer kann fehlgeschlagene Sendungen wiederholen"
    },
    "FollowUps": {
      "DueToast": "{{count}} Wiedervorlagen fällig",
      "Title": "Wiedervorlagen",
      "Subtitle": "E-Mails mit Wiedervorlage und offene Aufgaben mit Fälligkeitsdatum — fällig zuerst.",
      "Loading": "Wiedervorlagen werden geladen …",
      "Empty": "Keine Wiedervorlagen — nichts ist fällig.",
      "Overdue": "Fällig",
      "Upcoming": "Anstehend",
      "SnoozeDay": "Einen Tag verschieben",
      "SnoozeWeek": "Eine Woche verschieben",
      "Done": "Erledigt",
      "Search": "Wiedervorlagen durchsuchen …",
      "KindAll": "Alle",
      "KindEmails": "E-Mails",
      "KindTasks": "Aufgaben",
      "AllProperties": "Alle Objekte",
      "OnlyMine": "Nur meine",
      "DaysShort": " Tg. überfällig",
      "SortDueAsc": "Fällig ↑",
      "SortDueDesc": "Fällig ↓",
      "SortTitle": "Titel A–Z",
      "SortProperty": "Objekt",
      "ShowMore": "Mehr anzeigen",
      "Buckets": {
        "overdue": "Überfällig",
        "today": "Heute",
        "tomorrow": "Morgen",
        "week": "Diese Woche",
        "later": "Später"
      },
      "DateAll": "Alle Termine",
      "DateToday": "Heute",
      "DateTomorrow": "Morgen",
      "DateWeek": "Nächste 7 Tage",
      "DateMonth": "Nächste 30 Tage"
    },
    "Chat": {
      "Title": "KI-Assistent",
      "Placeholder": "Frage stellen oder Entwurf-Anweisung geben …",
      "Send": "Senden",
      "Apply": "In Entwurf übernehmen",
      "Applied": "Entwurf übernommen",
      "NoEditor": "Kein Entwurfs-Editor auf dieser Seite — Text bitte aus dem Chat kopieren",
      "Failed": "Der Assistent konnte nicht antworten — bitte erneut versuchen",
      "OpenConversation": "offene Unterhaltung"
    }
  },
  "EmailTask": {
    "Board": {
      "Title": "Aufgaben",
      "NewBoard": "Neues Board",
      "NewBoardPlaceholder": "Board-Name",
      "CreateBoard": "Anlegen",
      "FilterText": "Suchen (Key, Titel, Beschreibung)",
      "AllProperties": "Alle Objekte",
      "AllAssignees": "Alle Zuständigen",
      "Unassigned": "Nicht zugewiesen",
      "AllPriorities": "Alle Prioritäten",
      "ClearFilters": "Filter zurücksetzen",
      "DragPaused": "Verschieben bei aktivem Filter pausiert",
      "OpenEmail": "E-Mail öffnen",
      "ShowMore": "Weitere anzeigen",
      "Mine": "Meine",
      "Overdue": "Überfällig",
      "HideDone": "Erledigte ausblenden",
      "ToList": "Listenansicht",
      "NoSwimlanes": "Keine Gruppierung",
      "SwimlanesByProperty": "Gruppieren: Objekt",
      "SwimlanesByAssignee": "Gruppieren: Zuständige",
      "NoProperty": "Ohne Objekt",
      "InStatusSince": "Im Status seit {{days}} Tagen"
    },
    "Statuses": {
      "Backlog": "Eingang",
      "Todo": "Zu erledigen",
      "InProgress": "In Arbeit",
      "InReview": "In Prüfung",
      "Done": "Erledigt",
      "Dismissed": "Verworfen",
      "Suggested": "Vorschlag"
    },
    "List": {
      "Filter": {
        "Filter": "Suche"
      },
      "Key": "Nr.",
      "Title": "Titel",
      "Status": "Status",
      "Priority": "Priorität",
      "DueOn": "Fällig am",
      "Property": "Objekt",
      "Unit": "Einheit",
      "CreatedAt": "Erstellt am",
      "PageTitle": "Aufgabenliste",
      "ToBoard": "Zum Board"
    },
    "Dialog": {
      "DueOn": "Fällig",
      "Assignee": "Vorgeschlagen für",
      "Property": "Objekt",
      "Unit": "Einheit",
      "Contact": "Kontakt",
      "SourceEmail": "Zugehörige E-Mail",
      "OpenEmail": "E-Mail öffnen",
      "Close": "Schließen",
      "NewTask": "Neue Aufgabe",
      "Save": "Speichern",
      "Create": "Erstellen",
      "Cancel": "Abbrechen",
      "NoAssignee": "— niemand —",
      "SuggestedAssigneePlaceholder": "z.B. Hausmeister",
      "ConfirmDelete": "Aufgabe \"{{title}}\" wirklich löschen?",
      "LinkedDocument": "Verknüpftes Dokument öffnen",
      "Comments": "Kommentare",
      "Activity": "Verlauf",
      "DeleteComment": "Löschen",
      "RelatedTasks": "Verwandte Vorgänge",
      "UnknownAuthor": "Unbekannt",
      "CommentPlaceholder": "Kommentar schreiben …",
      "AddComment": "Kommentieren",
      "History": "Verlauf",
      "NoVorgang": "Kein Vorgang",
      "Attachments": "Anhänge",
      "NoAttachments": "Keine Anhänge — Dateien aus der E-Mail werden automatisch angehängt.",
      "AttachFile": "Datei anhängen",
      "RemoveAttachment": "Anhang entfernen",
      "Checklist": "Checkliste",
      "ChecklistItemPlaceholder": "Punkt beschreiben …",
      "AddChecklistItem": "+ Punkt hinzufügen",
      "RemoveChecklistItem": "Punkt entfernen",
      "InStatusSince": "Im Status seit {{days}} Tagen",
      "Time": "Zeit",
      "SpentMinutes": "Gebraucht",
      "Minutes": "Min.",
      "TimeNotePlaceholder": "Notiz (optional)",
      "RemoveTimeEntry": "Eintrag entfernen"
    },
    "Priorities": {
      "Low": "Niedrig",
      "Medium": "Mittel",
      "High": "Hoch",
      "Urgent": "Dringend"
    },
    "Fields": {
      "Title": "Titel",
      "Description": "Beschreibung",
      "Status": "Status",
      "Priority": "Priorität",
      "DueOn": "Fällig am",
      "Assignee": "Zugewiesen an",
      "SuggestedAssignee": "Vorschlag (Freitext)",
      "Labels": "Labels (kommagetrennt)",
      "Board": "Board",
      "Type": "Ebene",
      "Vorgang": "Vorgang",
      "EstimatedMinutes": "Geschätzt (Min.)"
    },
    "Toasts": {
      "Created": "Aufgabe erstellt",
      "Saved": "Aufgabe gespeichert",
      "Deleted": "Aufgabe gelöscht",
      "CommentFailed": "Kommentar konnte nicht gespeichert werden.",
      "SaveFailed": "Speichern fehlgeschlagen"
    },
    "Types": {
      "Task": "Aufgabe",
      "Vorgang": "Vorgang"
    },
    "Search for tasks": "Aufgaben und Vorgänge suchen",
    "Task": "Aufgabe",
    "EmailTasks": "Aufgaben",
    "Views": {
      "Saved": "Ansicht gespeichert",
      "ConfirmDelete": "Ansicht „{{name}}“ löschen?",
      "Shared": "Geteilt",
      "Delete": "Ansicht löschen",
      "NamePlaceholder": "Name der Ansicht …",
      "Save": "Speichern",
      "SaveCurrent": "Ansicht speichern"
    },
    "Bulk": {
      "MarkDone": "Erledigt",
      "MarkInProgress": "In Bearbeitung",
      "AssignToMe": "Mir zuweisen",
      "ClearAssignees": "Zuständigkeit entfernen",
      "ClearDueOn": "Fälligkeit entfernen"
    }
  },
  "Document": {
    "Documents": "Dokumente",
    "List": {
      "FileName": "Dateiname",
      "Type": "Typ",
      "Property": "Liegenschaft",
      "Source": "Quelle",
      "Size": "Größe",
      "CreatedAt": "Erstellt",
      "Filter": {
        "Filter": "Suche"
      },
      "FileType": "Dateityp",
      "ViewList": "Liste",
      "ViewGrid": "Kacheln",
      "Title": "Dokumente",
      "PageTitle": "Dokumente",
      "PageSubtitle": "Alle Dokumente des Bestands – über Struktur, Typ und Volltext filterbar."
    },
    "Types": {
      "Mietvertrag": "Mietvertrag",
      "Rechnung": "Rechnung",
      "Protokoll": "Protokoll",
      "Abrechnung": "Abrechnung",
      "Versicherungspolice": "Versicherungspolice",
      "Schriftverkehr": "Schriftverkehr",
      "Sonstiges": "Sonstiges",
      "Vertrag": "Vertrag",
      "Angebot": "Angebot",
      "Auftrag": "Auftrag",
      "Mahnung": "Mahnung",
      "Kuendigung": "Kündigung",
      "Schadensmeldung": "Schadensmeldung",
      "Teilungserklaerung": "Teilungserklärung",
      "Wirtschaftsplan": "Wirtschaftsplan",
      "Jahresabrechnung": "Jahresabrechnung",
      "Betriebskostenabrechnung": "Betriebskostenabrechnung",
      "Versicherungsschein": "Versicherungsschein",
      "Wartungsvertrag": "Wartungsvertrag",
      "Energieausweis": "Energieausweis",
      "Grundriss": "Grundriss",
      "Behoerdenschreiben": "Behördenschreiben"
    },
    "Sources": {
      "EmailAttachment": "E-Mail-Anhang",
      "DriveImport": "Drive-Import",
      "Upload": "Upload"
    },
    "Detail": {
      "Origins": "Herkunft",
      "OriginEmail": "E-Mail-Anhang",
      "Pages": "Seiten",
      "ToSourceEmail": "Zur E-Mail",
      "SourceEmail": "Quell-E-Mail",
      "Download": "Herunterladen",
      "NoPreview": "Für diesen Dateityp gibt es keine Vorschau.",
      "LoadingPreview": "Vorschau wird geladen …",
      "Metadata": "Metadaten",
      "OcrText": "Erkannter Text (OCR)",
      "Transcript": "Transkript"
    },
    "Fields": {
      "FileName": "Dateiname",
      "Size": "Größe",
      "Amount": "Betrag",
      "Property": "Objekt",
      "Unit": "Einheit",
      "Contact": "Kontakt",
      "CreatedAt": "Importiert am",
      "Description": "Beschreibung",
      "Tags": "Tags"
    },
    "Folders": {
      "All": "Alle Dokumente",
      "Units": "Einheiten",
      "Types": "Dokumenttypen"
    },
    "Search": {
      "Placeholder": "Dokumente durchsuchen (Volltext & Bedeutung) …",
      "NoResults": "Keine Treffer",
      "Close": "Suche schließen"
    },
    "Upload": {
      "File": "Datei",
      "ChooseFile": "Datei auswählen",
      "Title": "Titel",
      "TitlePlaceholder": "Leer = Dateiname",
      "Type": "Dokumenttyp",
      "Description": "Beschreibung",
      "Relations": "Zuordnung",
      "Relation": "Zuordnung",
      "NoFile": "Bitte zuerst eine Datei auswählen",
      "Done": "Dokument hochgeladen",
      "Action": "Dokument hochladen",
      "CreateTitle": "Dokument hochladen",
      "Subtitle": "Datei, Metadaten und optionale Zuordnungen für den direkten Upload ins DMS.",
      "BackToList": "Zurück",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Title": "Titel des Dokuments — leer lassen, dann wird der Dateiname verwendet.",
        "Type": "Dokumenttyp — steuert die Ablage; „Vertrag“ verknüpft mit dem Dienstleister.",
        "Description": "Optionale Beschreibung des Dokuments.",
        "Property": "Optional: das Objekt, dem das Dokument zugeordnet wird.",
        "Contact": "Optional: der Kontakt, dem das Dokument zugeordnet wird.",
        "Contractor": "Optional: der Dienstleister, dem das Dokument zugeordnet wird."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Dokument hochladen",
          "Description": "Dieses Formular lädt ein Dokument direkt ins DMS hoch. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "File": {
          "Title": "Datei",
          "Description": "Die hochzuladende Datei — PDF, Bilder oder Office-Dokumente. Ohne Datei kann nicht gespeichert werden."
        },
        "Title": {
          "Title": "Titel",
          "Description": "Titel des Dokuments — leer lassen, dann wird der Dateiname verwendet."
        },
        "Type": {
          "Title": "Dokumenttyp",
          "Description": "Steuert die Ablage; „Vertrag“ verknüpft das Dokument mit dem Dienstleister."
        },
        "Description": {
          "Title": "Beschreibung",
          "Description": "Optionale Beschreibung des Dokuments."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Optional: das Objekt, dem das Dokument zugeordnet wird."
        },
        "Contact": {
          "Title": "Kontakt",
          "Description": "Optional: der Kontakt, dem das Dokument zugeordnet wird."
        },
        "Contractor": {
          "Title": "Dienstleister",
          "Description": "Optional: der Dienstleister, dem das Dokument zugeordnet wird."
        },
        "Actions": {
          "Title": "Hochladen",
          "Description": "Speichern lädt die Datei hoch, führt die Texterkennung aus und legt das Dokument im DMS ab."
        }
      }
    },
    "Facets": {
      "Title": "Filter",
      "Clear": "Alle zurücksetzen",
      "properties": "Objekt",
      "units": "Einheit",
      "contacts": "Kontakt",
      "contractors": "Dienstleister",
      "types": "Dokumenttyp",
      "years": "Jahr",
      "sources": "Quelle",
      "tags": "Tags",
      "Amount": "Betrag",
      "Metadata": "Inhaltsmerkmale",
      "ExactValue": "Wert + Enter",
      "ExactNumber": "Zahl + Enter"
    },
    "Metadata": {
      "invoiceNumber": "Rechnungsnummer",
      "invoiceDate": "Rechnungsdatum",
      "dueDate": "Fälligkeit",
      "netAmount": "Nettobetrag",
      "grossAmount": "Bruttobetrag",
      "taxRate": "Steuersatz",
      "iban": "IBAN",
      "creditor": "Rechnungssteller",
      "customerNumber": "Kundennummer",
      "contractNumber": "Vertragsnummer",
      "contractStart": "Vertragsbeginn",
      "contractEnd": "Vertragsende",
      "noticePeriod": "Kündigungsfrist",
      "period": "Zeitraum",
      "meterNumber": "Zählernummer",
      "meterType": "Zählerart",
      "meterValue": "Zählerstand",
      "meterUnit": "Einheit",
      "readingDate": "Ablesedatum",
      "policyNumber": "Policennummer",
      "insurer": "Versicherer",
      "claimNumber": "Schadennummer",
      "orderNumber": "Auftragsnummer",
      "offerNumber": "Angebotsnummer",
      "validUntil": "Gültig bis",
      "sender": "Absender",
      "recipient": "Empfänger",
      "reference": "Aktenzeichen"
    },
    "Delete": {
      "Action": "Löschen",
      "Title": "Dokument löschen",
      "Reason": "Begründung",
      "ReasonPlaceholder": "z. B. Duplikat von DOC-123, versehentlich hochgeladen, falsches Objekt",
      "ReasonHint": "Pflichtfeld (GoBD): Die Datei bleibt erhalten, das Dokument verschwindet aus Liste und Suche. Das Löschen wird protokolliert.",
      "Done": "Dokument gelöscht (protokolliert)"
    },
    "Audit": {
      "Title": "Protokoll",
      "Actions": {
        "Created": "Angelegt",
        "Updated": "Geändert",
        "Deleted": "Gelöscht",
        "Restored": "Wiederhergestellt",
        "Downloaded": "Heruntergeladen",
        "IntegrityVerified": "Integrität geprüft",
        "IntegrityFailed": "INTEGRITÄT VERLETZT",
        "Disposed": "Kassiert",
        "LegalHoldSet": "Aufbewahrungssperre gesetzt",
        "LegalHoldReleased": "Aufbewahrungssperre aufgehoben",
        "CheckedOut": "Ausgecheckt",
        "CheckedIn": "Eingecheckt",
        "CheckoutDiscarded": "Check-out verworfen",
        "SharedDownload": "Extern heruntergeladen (Freigabe)",
        "ShareLinkCreated": "Freigabe-Link erstellt",
        "ShareLinkRevoked": "Freigabe-Link widerrufen",
        "Merged": "Dublette zusammengeführt"
      }
    },
    "Versions": {
      "NewVersion": "Neue Version",
      "Superseded": "Ersetzt durch neuere Version",
      "Predecessor": "Vorgängerversion"
    },
    "Governance": {
      "Title": "Governance",
      "SetHold": "Aufbewahrungssperre setzen",
      "LegalHoldPrompt": "Grund der Aufbewahrungssperre (min. 5 Zeichen):",
      "UnderLegalHold": "Aufbewahrungssperre aktiv — von der Kassation ausgeschlossen",
      "ReleaseHold": "Sperre aufheben (Admin)",
      "ReleaseHoldConfirm": "Aufbewahrungssperre wirklich aufheben?",
      "AdminOnly": "Nur Administratoren dürfen das",
      "Failed": "Aktion fehlgeschlagen",
      "Checkout": "Zur Bearbeitung auschecken",
      "CheckoutHint": "Reserviert die nächste Version",
      "CheckedOutBy": "Ausgecheckt von {{name}}",
      "Checkin": "Neue Version einchecken",
      "CheckedIn": "Version eingecheckt",
      "CheckinFailed": "Einchecken fehlgeschlagen",
      "CheckoutFailed": "Bereits von jemand anderem ausgecheckt",
      "DiscardCheckout": "Check-out verwerfen",
      "Shares": "Freigabe-Links",
      "ShareLink": "Freigabe-Link",
      "NoShares": "Keine Freigabe-Links",
      "ValidUntil": "gültig bis",
      "Revoked": "widerrufen",
      "CopyLink": "Link kopieren",
      "LinkCopied": "Link in die Zwischenablage kopiert",
      "Revoke": "Widerrufen",
      "RevokeShareConfirm": "Freigabe-Link widerrufen? Er funktioniert dann sofort nicht mehr.",
      "Days": "Tage",
      "MaxDownloads": "Max. Abrufe",
      "ShareNotePlaceholder": "Für wen? (z. B. Dachdecker Meier)",
      "CreateShare": "Link erstellen",
      "Similar": "Ähnliche Dokumente",
      "PossibleDuplicate": "Mögliche Dublette",
      "Merge": "Zusammenführen",
      "MergeConfirm": "„{{title}}“ in dieses Dokument zusammenführen? Aufgaben, Zuordnungen und Herkunft werden übernommen, die Dublette wird gelöscht (Datei und Protokoll bleiben erhalten).",
      "Merged": "Dublette zusammengeführt",
      "OwnOnly": "Nur eigene Einträge können entfernt werden"
    },
    "Annotations": {
      "Title": "Anmerkungen",
      "Empty": "Keine Anmerkungen — Notizen und Stempel verändern die Datei nie.",
      "AddNote": "Notiz",
      "AddStamp": "Stempel",
      "NotePrompt": "Text der Notiz:",
      "StampPrompt": "Stempeltext (z. B. GEPRÜFT, GEBUCHT):",
      "Kinds": {
        "Note": "Notiz",
        "Highlight": "Markierung",
        "Stamp": "Stempel"
      },
      "ClickToPlace": "In der Vorschau klicken, um zu platzieren"
    },
    "Schema": {
      "MissingRequired": "Pflichtfelder fehlen:",
      "InvalidKinds": "Ungültige Werte:"
    },
    "Retention": {
      "Label": "Aufbewahrung",
      "Permanent": "Dauerhaft",
      "Until": "{{years}} Jahre · bis",
      "Expired": "Frist abgelaufen"
    },
    "ShareFolders": {
      "Title": "Freigabe-Ordner",
      "Hint": "Ein Freigabe-Ordner bündelt mehrere Dokumente hinter EINEM ablaufenden Link. Externe (Handwerker, Eigentümer) sehen eine einfache Übersichtsseite; jeder Abruf wird am Dokument protokolliert.",
      "New": "Neuer Ordner",
      "Create": "Erstellen",
      "Name": "Name",
      "Note": "Notiz",
      "Empty": "Noch keine Freigabe-Ordner.",
      "EmptyFolder": "Noch keine Dokumente — auf dem Dokument-Detail über „Zu Freigabe-Ordner hinzufügen“ befüllen.",
      "RemoveDocument": "Entfernen",
      "ConfirmRevoke": "Freigabe-Ordner „{{name}}“ widerrufen? Der Link funktioniert dann sofort nicht mehr.",
      "SelectPlaceholder": "Zu Freigabe-Ordner hinzufügen …",
      "Add": "Hinzufügen",
      "Added": "Zum Freigabe-Ordner hinzugefügt",
      "Manage": "Ordner verwalten",
      "ToDocuments": "Zu den Dokumenten"
    }
  },
  "Mailbox": {
    "Mailboxes": "Postfächer",
    "List": {
      "Address": "Adresse",
      "DisplayName": "Anzeigename",
      "SyncEnabled": "Sync aktiv",
      "LastSyncedAt": "Letzter Sync",
      "EmailCount": "E-Mails",
      "Sync": "Jetzt synchronisieren",
      "Filter": {
        "Filter": "Suche"
      },
      "SyncRuns": "Sync-Verlauf",
      "Title": "Postfächer",
      "PageTitle": "Postfächer",
      "PageSubtitle": "Angebundene Postfächer der E-Mail-Intelligenz."
    },
    "Form": {
      "Settings": "Einstellungen",
      "DisplayName": "Anzeigename",
      "SyncEnabled": "Sync aktiviert",
      "StyleGuideSection": "Schreibstil des KI-Agenten",
      "AgentStyleGuide": "Stilrichtlinien",
      "AgentStyleGuidePlaceholder": "z.B.:\\nAnrede: Wer uns duzt, wird geduzt; sonst Sie.\\nGrußformel: \"Mit freundlichen Grüßen\" + Vorname Nachname.\\nTon: freundlich, klar, kurze Sätze, keine Floskeln.\\nSignatur: immer die vollständige Firmensignatur.\\nNo-Gos: keine Zusagen zu Kosten oder Terminen ohne Rücksprache.",
      "AgentSignature": "Standard-Signatur",
      "AgentSignaturePlaceholder": "Mit freundlichen Grüßen<br><br><strong>Ambos Immo</strong><br>Sieker Landstr. 233<br>22927 Großhansdorf<br>Tel.: +49 4102 6649052<br>Internet: <a href=\"https://www.ambos-immo.de\">www.ambos-immo.de</a>",
      "AssignedUser": "Zuständige/r Mitarbeiter/in",
      "NoAssignedUser": "— keine Zuständigkeit —",
      "ImportExcludedSenders": "Absender vom Import ausschließen",
      "ImportExcludedSendersPlaceholder": "noreply@beispiel.de\n@newsletter-domain.de",
      "ImportExcludedSendersHint": "Eine Adresse pro Zeile — exakte Adresse oder ganze Domain mit führendem @. Wirkt nur auf NEUE Importe; bereits importierte Mails bleiben.",
      "CreateTitle": "Postfach anlegen",
      "EditTitle": "Postfach bearbeiten",
      "Subtitle": "Einstellungen des Postfachs — Synchronisierung, Stilvorgaben und Zuständigkeit.",
      "BackToList": "Zur Postfachliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "DisplayName": "Anzeigename des Postfachs, wie er überall in der Anwendung erscheint.",
        "SyncEnabled": "Wenn aktiv, werden neue E-Mails dieses Postfachs laufend synchronisiert.",
        "AgentStyleGuide": "Stilvorgaben, an die sich der KI-Assistent bei Antwortentwürfen aus diesem Postfach hält.",
        "AgentSignature": "Signatur, die der KI-Assistent unter Antwortentwürfe aus diesem Postfach setzt.",
        "ImportExcludedSenders": "Ein Absender pro Zeile (Adresse oder @domain) — neue Mails dieser Absender werden nicht importiert.",
        "AssignedUser": "Mitarbeiter/in, die für dieses Postfach zuständig ist."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Postfach bearbeiten",
          "Description": "Dieses Formular verwaltet die Einstellungen eines Postfachs. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "DisplayName": {
          "Title": "Anzeigename",
          "Description": "Name des Postfachs, wie er überall in der Anwendung erscheint."
        },
        "SyncEnabled": {
          "Title": "Synchronisierung",
          "Description": "Steuert, ob neue E-Mails dieses Postfachs laufend abgeholt und verarbeitet werden."
        },
        "AgentStyleGuide": {
          "Title": "Stilvorgaben",
          "Description": "Freitext-Vorgaben (Tonfall, Anrede, Formulierungen), an die sich der KI-Assistent bei Antwortentwürfen hält."
        },
        "AgentSignature": {
          "Title": "Signatur",
          "Description": "Diese Signatur setzt der KI-Assistent unter jeden Antwortentwurf aus diesem Postfach."
        },
        "ImportExcludedSenders": {
          "Title": "Ausgeschlossene Absender",
          "Description": "Ein Eintrag pro Zeile — exakte Adresse oder @domain. Betrifft nur NEUE Importe; bereits importierte Mails bleiben erhalten."
        },
        "AssignedUser": {
          "Title": "Zuständigkeit",
          "Description": "Die zuständige Person wird bei Aufgaben und Wiedervorlagen aus diesem Postfach vorgeschlagen."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern übernimmt die Einstellungen. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick springt direkt zum Feld."
        }
      }
    },
    "Toasts": {
      "SyncStarted": "Synchronisierung gestartet",
      "Updated": "Postfach gespeichert"
    },
    "SyncRuns": {
      "Title": "Sync-Verlauf",
      "StartedAt": "Gestartet",
      "Duration": "Fertig um",
      "Fetched": "Abgerufen",
      "FailedFolders": "Fehlgeschl. Ordner",
      "Error": "Fehler",
      "Running": "läuft …",
      "Empty": "Noch keine Läufe."
    }
  },
  "DriveImport": {
    "DriveImports": "Drive-Importe",
    "List": {
      "RootFolder": "Stammordner",
      "Status": "Status",
      "DryRun": "Testlauf",
      "Progress": "Ergebnis",
      "CreatedAt": "Gestartet",
      "Create": "Neuer Import",
      "Resume": "Fortsetzen",
      "SyncDiff": "Differenz-Sync",
      "Filter": {
        "Filter": "Suche"
      },
      "Stop": "Stoppen",
      "StartedAt": "Gestartet",
      "PageTitle": "Drive-Importe",
      "PageSubtitle": "Import-Läufe aus dem Dokumenten-Drive."
    },
    "Statuses": {
      "Pending": "Wartend",
      "Running": "Läuft",
      "Completed": "Abgeschlossen",
      "Failed": "Fehlgeschlagen",
      "Cancelled": "Gestoppt"
    },
    "Form": {
      "Settings": "Import-Einstellungen",
      "RootFolder": "Drive-Ordner (ID oder URL)",
      "RootFolderPlaceholder": "Ordner-ID oder Freigabe-URL",
      "DryRun": "Testlauf (nur zählen)",
      "MirrorDeletions": "Löschungen übernehmen",
      "CreateTitle": "Drive-Import anlegen",
      "EditTitle": "Drive-Import bearbeiten",
      "Subtitle": "Einstellungen des Imports — Quellordner und Verhalten des Laufs.",
      "BackToList": "Zur Importliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "RootFolder": "Pfad des Quellordners im Laufwerk, aus dem die Dokumente importiert werden.",
        "DryRun": "Testlauf: der Import wird nur simuliert, es wird nichts geschrieben.",
        "MirrorDeletions": "Wenn aktiv, werden im Quellordner gelöschte Dateien auch hier entfernt."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Drive-Import anlegen",
          "Description": "Dieses Formular startet einen Dokumentenimport aus einem Laufwerksordner. Der Rundgang führt durch alle Einstellungen."
        },
        "RootFolder": {
          "Title": "Quellordner",
          "Description": "Pfad des Ordners, dessen Inhalt importiert wird."
        },
        "DryRun": {
          "Title": "Testlauf",
          "Description": "Bei aktivem Testlauf wird der Import nur simuliert — ideal, um das Ergebnis vorab zu prüfen."
        },
        "MirrorDeletions": {
          "Title": "Löschungen spiegeln",
          "Description": "Entfernt Dokumente, deren Quelldateien im Ordner nicht mehr existieren. Mit Bedacht aktivieren."
        },
        "Actions": {
          "Title": "Starten",
          "Description": "Speichern legt den Importlauf an und startet ihn mit den gewählten Einstellungen."
        }
      }
    },
    "Toasts": {
      "Created": "Import gestartet",
      "Resumed": "Import fortgesetzt",
      "SyncDiffStarted": "Differenz-Sync gestartet",
      "Cancelled": "Import gestoppt"
    }
  },
  "GlobalSearch": {
    "Open": "Suche"
  },
  "Contact": {
    "Detail": {
      "Emails": "Korrespondenz",
      "NoEmails": "Keine E-Mails mit diesem Kontakt.",
      "Tabs": {
        "Overview": "Übersicht",
        "BankAccounts": "Bankkonten",
        "Documents": "Dokumente",
        "Emails": "Korrespondenz",
        "Tasks": "Aufgaben",
        "Activities": "Aktivitäten"
      },
      "NoActivities": "Keine Aktivitäten"
    },
    "Contractors": {
      "Title": "Arbeitet bei",
      "Until": "bis",
      "Empty": "Keinem Dienstleister zugeordnet"
    },
    "Search for contacts": "Suche nach Kontakten",
    "Types": {
      "Person": "Person",
      "Company": "Firma"
    },
    "Actions": {
      "Create": "Kontakt anlegen"
    },
    "BankAccounts": {
      "Title": "Bankkonten"
    },
    "Contact": "Kontakt",
    "Form": {
      "Address": "Adresse",
      "IsAdvisoryBoard": "Beiratsmitglied",
      "MasterData": "Stammdaten",
      "Weg": "WEG",
      "Connections": "Verknüpfungen",
      "Unit": "Einheit (optional)",
      "UnitRole": "Rolle in der Einheit",
      "Contractor": "Dienstleister (optional)",
      "CreateUnit": "Neue Einheit anlegen",
      "CreateContractor": "Neuen Dienstleister anlegen",
      "Email": "E-Mail",
      "Name": "Name / Firma",
      "PhoneNumber": "Telefon",
      "Type": "Typ",
      "CreateTitle": "Kontakt anlegen",
      "EditTitle": "Kontakt bearbeiten",
      "Subtitle": "Stammdaten des Kontakts — Name, Erreichbarkeit, Adresse und Verknüpfungen.",
      "BackToList": "Zur Kontaktliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Name": "Vollständiger Name der Person oder Firmenname.",
        "Type": "Person oder Firma — bestimmt, wie der Kontakt geführt wird.",
        "Email": "E-Mail-Adresse des Kontakts — wird für die automatische Zuordnung eingehender Mails genutzt.",
        "PhoneNumber": "Telefonnummer des Kontakts.",
        "Unit": "Optional: Einheit, mit der der Kontakt direkt beim Anlegen verknüpft wird.",
        "UnitRole": "Rolle des Kontakts in der gewählten Einheit — Eigentümer oder Mieter.",
        "Contractor": "Optional: Dienstleister, bei dem der Kontakt als Ansprechpartner geführt wird.",
        "IsAdvisoryBoard": "Kennzeichnet den Kontakt als Mitglied des Verwaltungsbeirats.",
        "FirstName": "Vorname der Person.",
        "LastName": "Nachname der Person."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Kontakt anlegen",
          "Description": "Dieses Formular legt einen neuen Kontakt an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Vollständiger Name der Person oder Firmenname. Pflichtfeld."
        },
        "Type": {
          "Title": "Typ",
          "Description": "Person oder Firma — bestimmt, wie der Kontakt geführt wird."
        },
        "Email": {
          "Title": "E-Mail",
          "Description": "E-Mail-Adresse des Kontakts — eingehende Mails dieser Adresse werden automatisch zugeordnet."
        },
        "PhoneNumber": {
          "Title": "Telefon",
          "Description": "Telefonnummer des Kontakts."
        },
        "Address": {
          "Title": "Adresse",
          "Description": "Postanschrift des Kontakts — Straße, Hausnummer, PLZ und Ort."
        },
        "Unit": {
          "Title": "Einheit",
          "Description": "Optional: verknüpft den Kontakt direkt mit einer Einheit. Nach der Auswahl erscheint das Rollenfeld (Eigentümer oder Mieter)."
        },
        "Contractor": {
          "Title": "Dienstleister",
          "Description": "Optional: führt den Kontakt als Ansprechpartner bei einem Dienstleister."
        },
        "IsAdvisoryBoard": {
          "Title": "Verwaltungsbeirat",
          "Description": "Kennzeichnet den Kontakt als Mitglied des Verwaltungsbeirats."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt den Kontakt an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        },
        "FirstName": {
          "Title": "Vorname",
          "Description": "Der Vorname der Person — der Anzeigename wird automatisch zusammengesetzt."
        },
        "LastName": {
          "Title": "Nachname",
          "Description": "Der Nachname der Person — Pflichtfeld bei Personen."
        }
      },
      "FirstName": "Vorname",
      "LastName": "Nachname"
    },
    "List": {
      "AdvisoryBoard": "Beirat",
      "Email": "E-Mail",
      "Phone": "Telefon",
      "Type": "Typ",
      "City": "Stadt",
      "Filter": {
        "City": "Stadt",
        "Email": "E-Mail",
        "Filter": "Suche",
        "Name": "Name",
        "Types": "Typen"
      },
      "Name": "Name",
      "PageTitle": "Kontakte",
      "PageSubtitle": "Eigentümer, Mieter und Ansprechpartner."
    },
    "Toasts": {
      "Created": "Kontakt angelegt.",
      "Updated": "Kontakt gespeichert."
    },
    "Units": {
      "Title": "Einheiten",
      "Empty": "Keiner Einheit zugeordnet"
    }
  },
  "Assistant": {
    "Title": "KI-Assistent",
    "Hint": "Fragen zum gesamten Bestand — E-Mails, Objekte, Kontakte, Dokumente. Antworten sind belegt; Quellen sind anklickbar.",
    "Placeholder": "Frage stellen, z. B. „Welche Mails zur Musterstraße 1 sind noch offen?“",
    "Reset": "Neu starten",
    "Suggestions": {
      "OpenReplies": "Welche E-Mails der letzten Woche warten noch auf eine Antwort?",
      "MeterReadings": "Welche Zählerstände wurden zuletzt gemeldet?",
      "LatestInvoice": "Was war die letzte Rechnung eines Handwerkers und für welches Objekt?"
    },
    "Sources": "Quellen:",
    "NewThread": "+ Neue Unterhaltung",
    "LegacyThread": "Früherer Verlauf"
  },
  "Shared": {
    "Remove": "Entfernen",
    "Loading": "Lädt …",
    "No": "Nein",
    "View": "Ansehen",
    "Yes": "Ja"
  },
  "Relations": {
    "Title": "Zuordnung",
    "None": "Keine Zuordnung",
    "Set": "Zuordnen",
    "Edit": "Zuordnung ändern",
    "Save": "Speichern",
    "Clear": "Zuordnung entfernen",
    "Saved": "Zuordnung gespeichert",
    "Failed": "Zuordnung konnte nicht gespeichert werden",
    "Property": "Objekt",
    "Unit": "Einheit",
    "Contact": "Kontakt",
    "Contractor": "Dienstleister",
    "Contract": "Vertrag",
    "SuggestedByTrade": "Zuständig für {{ trade }} an diesem Objekt",
    "SuggestedByProperty": "Dienstleister dieses Objekts",
    "SuggestedByPipeline": "Vorschlag der KI-Analyse",
    "More": "Weitere Zuordnungen",
    "NoneMore": "Keine weiteren",
    "Add": "Hinzufügen",
    "Task": "Aufgabe / Vorgang",
    "UnitNeedsProperty": "Zuerst ein Objekt zuordnen — Einheiten werden im Objekt gesucht."
  },
  "Contractor": {
    "Contractors": "Dienstleister",
    "Contractor": "Dienstleister",
    "Search for contractors": "Dienstleister suchen",
    "Inactive": "inaktiv",
    "Actions": {
      "Create": "Dienstleister anlegen"
    },
    "List": {
      "Name": "Name",
      "Trades": "Gewerke",
      "Phone": "Telefon",
      "City": "Ort",
      "ActiveAssignments": "Aktive Zuordnungen",
      "Active": "Aktiv",
      "Filter": {
        "Filter": "Suchen",
        "Name": "Name",
        "Trade": "Gewerk",
        "City": "Ort"
      },
      "PageTitle": "Dienstleister",
      "PageSubtitle": "Alle Dienstleister mit Verträgen und Zuordnungen."
    },
    "Sections": {
      "MasterData": "Stammdaten",
      "Contacts": "Ansprechpartner",
      "Contracts": "Verträge",
      "Assignments": "Zuordnungen",
      "Emails": "E-Mails",
      "Documents": "Dokumente",
      "Tasks": "Aufgaben"
    },
    "Contacts": {
      "Add": "Ansprechpartner",
      "Function": "Funktion",
      "Primary": "primär",
      "MakePrimary": "als primär",
      "Empty": "Noch keine Ansprechpartner"
    },
    "Contracts": {
      "Add": "Vertrag",
      "Title": "Titel",
      "Number": "Vertragsnummer",
      "Kind": "Art",
      "Start": "Beginn",
      "End": "Ende",
      "OpenEnded": "unbefristet",
      "NoticeMonths": "Kündigungsfrist (Monate)",
      "RenewMonths": "Verlängerung (Monate)",
      "Billing": "Abrechnung",
      "Amount": "Betrag (netto)",
      "HourlyRate": "Stundensatz",
      "Empty": "Noch keine Verträge",
      "UploadFile": "Datei hochladen"
    },
    "Kinds": {
      "Rahmenvertrag": "Rahmenvertrag",
      "Wartungsvertrag": "Wartungsvertrag",
      "Dienstleistungsvertrag": "Dienstleistungsvertrag",
      "Einzelauftrag": "Einzelauftrag"
    },
    "Intervals": {
      "Monatlich": "monatlich",
      "Quartal": "quartalsweise",
      "Jaehrlich": "jährlich",
      "NachAufwand": "nach Aufwand"
    },
    "Assignments": {
      "Add": "Zuordnung",
      "Trade": "Gewerk",
      "From": "Von",
      "To": "Bis",
      "Ongoing": "laufend",
      "Contract": "Vertrag",
      "End": "Beenden",
      "Empty": "Noch keine Zuordnungen"
    },
    "Toasts": {
      "Created": "Angelegt",
      "Updated": "Gespeichert",
      "Saved": "Gespeichert",
      "Failed": "Speichern fehlgeschlagen"
    },
    "Form": {
      "MasterData": "Stammdaten",
      "Address": "Adresse",
      "More": "Weiteres",
      "Name": "Name",
      "Trades": "Gewerke",
      "TradesPlaceholder": "Gewerk eingeben und Enter",
      "Email": "E-Mail",
      "Phone": "Telefon",
      "EmergencyPhone": "Notdienst",
      "EmergencyPhoneHint": "Die Nummer, die bei Rohrbruch nachts gewählt wird",
      "Website": "Website",
      "Notes": "Notizen",
      "NotesPlaceholder": "Konditionen, Besonderheiten, Rahmenvereinbarungen …",
      "Active": "Aktiv",
      "CreateTitle": "Dienstleister anlegen",
      "EditTitle": "Dienstleister bearbeiten",
      "Subtitle": "Stammdaten des Dienstleisters — Gewerke, Erreichbarkeit und Adresse.",
      "BackToList": "Zur Dienstleisterliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Name": "Firmenname des Dienstleisters.",
        "Trades": "Gewerke des Dienstleisters, z. B. Sanitär oder Elektro — Eingabe mit Enter bestätigen.",
        "Email": "E-Mail-Adresse der Firma — wird für die automatische Zuordnung eingehender Mails genutzt.",
        "Phone": "Telefonnummer der Firma.",
        "EmergencyPhone": "Notfallnummer für dringende Fälle außerhalb der Geschäftszeiten.",
        "Website": "Webseite der Firma, z. B. https://beispiel.de.",
        "Notes": "Interne Notizen zum Dienstleister — nur für das Team sichtbar.",
        "Active": "Inaktive Dienstleister werden bei Vorschlägen und Zuordnungen nicht mehr angeboten."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Dienstleister anlegen",
          "Description": "Dieses Formular legt einen neuen Dienstleister an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Firmenname des Dienstleisters. Pflichtfeld."
        },
        "Trades": {
          "Title": "Gewerke",
          "Description": "Gewerke des Dienstleisters, z. B. Sanitär oder Elektro — Eingabe mit Enter bestätigen. Grundlage für automatische Vorschläge."
        },
        "Email": {
          "Title": "E-Mail",
          "Description": "E-Mail-Adresse der Firma — eingehende Mails dieser Adresse (und ihrer Domain) werden automatisch zugeordnet."
        },
        "PhoneNumber": {
          "Title": "Telefon",
          "Description": "Telefonnummer der Firma."
        },
        "EmergencyPhone": {
          "Title": "Notfallnummer",
          "Description": "Nummer für dringende Fälle außerhalb der Geschäftszeiten."
        },
        "Website": {
          "Title": "Webseite",
          "Description": "Webseite der Firma, z. B. https://beispiel.de."
        },
        "Address": {
          "Title": "Adresse",
          "Description": "Postanschrift der Firma — Straße, Hausnummer, PLZ und Ort."
        },
        "Notes": {
          "Title": "Notizen",
          "Description": "Interne Notizen zum Dienstleister — nur für das Team sichtbar."
        },
        "Active": {
          "Title": "Aktiv",
          "Description": "Inaktive Dienstleister werden bei Vorschlägen und Zuordnungen nicht mehr angeboten."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt den Dienstleister an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "ContactForm": {
      "Connection": "Verknüpfung",
      "Validity": "Gültigkeit",
      "Contact": "Kontakt",
      "Function": "Funktion",
      "FunctionPlaceholder": "Disponent, Geschäftsführung, Notdienst …",
      "Primary": "Primärer Ansprechpartner",
      "ValidFrom": "Gültig ab",
      "ValidTo": "Gültig bis",
      "CreateTitle": "Ansprechpartner hinzufügen",
      "EditTitle": "Ansprechpartner bearbeiten",
      "Subtitle": "Verknüpfung eines Kontakts als Ansprechpartner des Dienstleisters.",
      "BackToList": "Zum Dienstleister",
      "StartTour": "Ausfüllhilfe starten",
      "ContactRequired": "Kontakt ist erforderlich",
      "Info": {
        "Contact": "Der Kontakt, der als Ansprechpartner des Dienstleisters geführt wird.",
        "Function": "Funktion des Ansprechpartners, z. B. Disposition oder Buchhaltung.",
        "Primary": "Kennzeichnet den Hauptansprechpartner des Dienstleisters.",
        "ValidFrom": "Optional: Beginn der Tätigkeit als Ansprechpartner.",
        "ValidTo": "Optional: Ende der Tätigkeit — leer bedeutet unbefristet."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Ansprechpartner hinzufügen",
          "Description": "Dieses Formular verknüpft einen bestehenden Kontakt als Ansprechpartner des Dienstleisters. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Contact": {
          "Title": "Kontakt",
          "Description": "Der Kontakt, der als Ansprechpartner geführt wird. Pflichtfeld."
        },
        "Function": {
          "Title": "Funktion",
          "Description": "Funktion des Ansprechpartners, z. B. Disposition oder Buchhaltung."
        },
        "Primary": {
          "Title": "Hauptansprechpartner",
          "Description": "Kennzeichnet den Hauptansprechpartner des Dienstleisters."
        },
        "ValidFrom": {
          "Title": "Gültig ab",
          "Description": "Optional: Beginn der Tätigkeit als Ansprechpartner."
        },
        "ValidTo": {
          "Title": "Gültig bis",
          "Description": "Optional: Ende der Tätigkeit — leer bedeutet unbefristet."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern verknüpft den Ansprechpartner. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "ContractForm": {
      "Contract": "Vertrag",
      "Term": "Laufzeit",
      "Conditions": "Konditionen",
      "Title": "Titel",
      "TitlePlaceholder": "z. B. Rahmenvertrag Gartenpflege 2026",
      "Number": "Vertragsnummer",
      "Kind": "Art",
      "Start": "Beginn",
      "End": "Ende",
      "EndHint": "Leer = unbefristet",
      "NoticeMonths": "Kündigungsfrist (Monate)",
      "RenewMonths": "Automatische Verlängerung (Monate)",
      "RenewMonthsHint": "0 oder leer = keine Verlängerung",
      "Billing": "Abrechnung",
      "Amount": "Betrag (netto)",
      "HourlyRate": "Stundensatz",
      "Notes": "Notizen",
      "CreateTitle": "Vertrag anlegen",
      "EditTitle": "Vertrag bearbeiten",
      "Subtitle": "Vertragsdaten des Dienstleisters — Laufzeit, Fristen und Konditionen.",
      "BackToList": "Zum Dienstleister",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Title": "Bezeichnung des Vertrags, z. B. „Wartung Aufzugsanlage“.",
        "Number": "Vertragsnummer laut Vertragsdokument.",
        "Kind": "Art des Vertrags: Rahmen-, Wartungs-, Dienstleistungsvertrag oder Einzelauftrag.",
        "Start": "Beginn der Vertragslaufzeit.",
        "End": "Optional: Ende der Laufzeit — Grundlage für die automatische Fristenüberwachung.",
        "NoticeMonths": "Kündigungsfrist in ganzen Monaten vor Vertragsende.",
        "RenewMonths": "Automatische Verlängerung in ganzen Monaten, wenn nicht gekündigt wird.",
        "Billing": "Abrechnungsintervall: monatlich, quartalsweise, jährlich oder nach Aufwand.",
        "Amount": "Betrag pro Abrechnungsintervall in Euro.",
        "HourlyRate": "Vereinbarter Stundensatz in Euro.",
        "Notes": "Interne Notizen zum Vertrag — nur für das Team sichtbar."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Vertrag anlegen",
          "Description": "Dieses Formular legt einen Vertrag des Dienstleisters an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Title": {
          "Title": "Titel",
          "Description": "Bezeichnung des Vertrags, z. B. „Wartung Aufzugsanlage“. Pflichtfeld."
        },
        "Number": {
          "Title": "Vertragsnummer",
          "Description": "Vertragsnummer laut Vertragsdokument."
        },
        "Kind": {
          "Title": "Vertragsart",
          "Description": "Rahmen-, Wartungs-, Dienstleistungsvertrag oder Einzelauftrag."
        },
        "Start": {
          "Title": "Beginn",
          "Description": "Beginn der Vertragslaufzeit. Pflichtfeld."
        },
        "End": {
          "Title": "Ende",
          "Description": "Optional: Ende der Laufzeit — aus Ende und Kündigungsfrist berechnet die Fristenüberwachung den letzten Kündigungstag."
        },
        "NoticeMonths": {
          "Title": "Kündigungsfrist",
          "Description": "Kündigungsfrist in ganzen Monaten vor Vertragsende."
        },
        "RenewMonths": {
          "Title": "Automatische Verlängerung",
          "Description": "Verlängerung in ganzen Monaten, wenn nicht rechtzeitig gekündigt wird — Fristen-Tasks erhalten dann hohe Priorität."
        },
        "Billing": {
          "Title": "Abrechnung",
          "Description": "Abrechnungsintervall: monatlich, quartalsweise, jährlich oder nach Aufwand."
        },
        "Amount": {
          "Title": "Betrag",
          "Description": "Betrag pro Abrechnungsintervall in Euro."
        },
        "HourlyRate": {
          "Title": "Stundensatz",
          "Description": "Vereinbarter Stundensatz in Euro."
        },
        "Notes": {
          "Title": "Notizen",
          "Description": "Interne Notizen zum Vertrag — nur für das Team sichtbar."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt den Vertrag an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "AssignmentForm": {
      "Where": "Wo & was",
      "When": "Wann",
      "Property": "Objekt",
      "Unit": "Einheit",
      "Trade": "Gewerk",
      "TradePlaceholder": "Sanitär, Elektro, Garten …",
      "ValidFrom": "Von",
      "ValidTo": "Bis",
      "ValidToHint": "Leer = laufend",
      "Contract": "Vertrag",
      "NoContract": "– kein Vertrag –",
      "Notes": "Notiz",
      "CreateTitle": "Zuordnung anlegen",
      "EditTitle": "Zuordnung bearbeiten",
      "Subtitle": "Zuständigkeit des Dienstleisters — Objekt, Gewerk und Zeitraum.",
      "BackToList": "Zum Dienstleister",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "SelectPropertyFirst": "Bitte zuerst ein Objekt wählen.",
      "Info": {
        "Property": "Das Objekt, für das der Dienstleister zuständig ist — schaltet die Einheitenauswahl frei.",
        "Unit": "Optional: eine einzelne Einheit — leer bedeutet das ganze Objekt.",
        "Trade": "Das Gewerk der Zuordnung, z. B. Sanitär — genau ein Gewerk pro Zuordnung.",
        "ValidFrom": "Beginn der Zuständigkeit.",
        "ValidTo": "Optional: Ende der Zuständigkeit — leer bedeutet unbefristet.",
        "Contract": "Optional: der zugrunde liegende Vertrag des Dienstleisters.",
        "Notes": "Interne Notizen zur Zuordnung — nur für das Team sichtbar."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Zuordnung anlegen",
          "Description": "Dieses Formular legt fest, wo und wofür der Dienstleister zuständig ist. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Zuerst das Objekt wählen — es schaltet die Einheitenauswahl frei. Pflichtfeld."
        },
        "Unit": {
          "Title": "Einheit",
          "Description": "Optional: eine einzelne Einheit im gewählten Objekt — leer bedeutet das ganze Objekt."
        },
        "Trade": {
          "Title": "Gewerk",
          "Description": "Das Gewerk der Zuordnung, z. B. Sanitär — genau ein Gewerk pro Zuordnung. Pflichtfeld."
        },
        "ValidFrom": {
          "Title": "Gültig ab",
          "Description": "Beginn der Zuständigkeit. Pflichtfeld."
        },
        "ValidTo": {
          "Title": "Gültig bis",
          "Description": "Optional: Ende der Zuständigkeit — leer bedeutet unbefristet."
        },
        "Contract": {
          "Title": "Vertrag",
          "Description": "Optional: der zugrunde liegende Vertrag des Dienstleisters."
        },
        "Notes": {
          "Title": "Notizen",
          "Description": "Interne Notizen zur Zuordnung — nur für das Team sichtbar."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Zuordnung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "Import": {
      "Action": "Liste importieren",
      "Run": "Importieren",
      "Hint": "Direkt aus Excel kopieren (Tabs) oder CSV einfügen — eine Firma pro Zeile. Spalten: Name; Gewerke; E-Mail; Telefon; Notfall; Straße; PLZ; Ort; Web; Notizen (Kopfzeile mit \"Name\" wird erkannt, Reihenfolge sonst wie angegeben). Bestehende Firmen werden nur ergänzt, nie überschrieben.",
      "Placeholder": "Name\tGewerke\tE-Mail\tTelefon\nClemens Keibel Gebäudetechnik\tSanitär, Heizung\tinfo@keibel.de\t040 123456",
      "Done": "{{created}} angelegt, {{updated}} ergänzt, {{skipped}} übersprungen.",
      "Failed": "Import fehlgeschlagen."
    }
  },
  "Unit": {
    "Search for units": "Suche nach Einheiten",
    "Actions": {
      "Create": "Einheit anlegen",
      "OwnershipChange": "Eigentümerwechsel",
      "TenantChange": "Mieterwechsel"
    },
    "Form": {
      "Figures": "Kennzahlen",
      "MasterData": "Stammdaten",
      "CreateTitle": "Einheit anlegen",
      "EditTitle": "Einheit bearbeiten",
      "Subtitle": "Stammdaten der Einheit — Nummer, Typ, Gebäude und Kennzahlen.",
      "BackToList": "Zur Einheitenliste",
      "Property": "Objekt",
      "Area": "Fläche (m²)",
      "BuildingId": "Gebäude",
      "Name": "Name",
      "Number": "Nummer",
      "Share": "Miteigentumsanteile",
      "Type": "Typ",
      "SelectPropertyFirst": "Bitte zuerst ein Objekt wählen.",
      "PropertyRequired": "Objekt ist erforderlich",
      "BuildingRequired": "Gebäude ist erforderlich",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Name": "Bezeichnung der Einheit, z. B. „Wohnung 3. OG links“.",
        "Number": "Fortlaufende Nummer der Einheit im Objekt — nur ganze Zahlen.",
        "Type": "Art der Einheit: Wohnung, Gewerbe, Garage oder Stellplatz.",
        "Property": "Das Objekt, zu dem die Einheit gehört — schaltet die Gebäudeauswahl frei.",
        "Building": "Das Gebäude im gewählten Objekt. Bei nur einem Gebäude (oder einem „Hauptgebäude“) wird es automatisch gewählt.",
        "Share": "Miteigentumsanteile (MEA) — Dezimalzahl mit Komma, z. B. 51,25.",
        "Area": "Fläche in m² — Dezimalzahl mit Komma, z. B. 76,5."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Einheit anlegen",
          "Description": "Dieses Formular legt eine neue Einheit an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Bezeichnung der Einheit, z. B. „Wohnung 3. OG links“. Pflichtfeld."
        },
        "Number": {
          "Title": "Nummer",
          "Description": "Fortlaufende Nummer der Einheit im Objekt — nur ganze Zahlen. Beim Anlegen aus der Objekt-Struktur wird die nächste freie Nummer vorgeschlagen."
        },
        "Type": {
          "Title": "Typ",
          "Description": "Art der Einheit: Wohnung, Gewerbe, Garage oder Stellplatz."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Zuerst das Objekt wählen — es schaltet die Gebäudeauswahl frei. Bei nur einem Gebäude (oder einem „Hauptgebäude“) wird das Gebäude automatisch gesetzt."
        },
        "Building": {
          "Title": "Gebäude",
          "Description": "Das Gebäude im gewählten Objekt, zu dem die Einheit gehört."
        },
        "Share": {
          "Title": "Miteigentumsanteile",
          "Description": "MEA der Einheit als Dezimalzahl mit Komma, z. B. 51,25."
        },
        "Area": {
          "Title": "Fläche",
          "Description": "Wohn-/Nutzfläche in m² als Dezimalzahl mit Komma, z. B. 76,5."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Einheit an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "List": {
      "Area": "Fläche",
      "Property": "Objekt",
      "Share": "MEA",
      "Type": "Art",
      "Number": "Nummer",
      "Building": "Gebäude",
      "CurrentOwner": "Aktuelle Eigentümer",
      "Filter": {
        "BuildingIds": "Gebäude",
        "Filter": "Suche",
        "Name": "Name",
        "PropertyIds": "Objekte",
        "Types": "Typen"
      },
      "Name": "Name",
      "PageTitle": "Einheiten",
      "PageSubtitle": "Alle Einheiten über alle Objekte."
    },
    "Timeline": {
      "OwnerTitle": "Eigentümerverlauf",
      "TenantTitle": "Mieterverlauf"
    },
    "Toasts": {
      "Created": "Einheit angelegt.",
      "Updated": "Einheit gespeichert."
    },
    "Unit": "Einheit",
    "Types": {
      "Apartment": "Wohnung",
      "Commercial": "Gewerbe",
      "Garage": "Garage",
      "Parking": "Stellplatz"
    },
    "Detail": {
      "Tabs": {
        "Overview": "Übersicht",
        "Documents": "Dokumente",
        "Emails": "Korrespondenz",
        "Tasks": "Aufgaben",
        "Activities": "Aktivitäten"
      },
      "NoTasks": "Keine Aufgaben für diese Einheit.",
      "NoActivities": "Keine Aktivitäten für diese Einheit."
    }
  },
  "AgentConfiguration": {
    "Title": "KI-Agent der Verwaltung",
    "Intro": "Hier bekommt der Schreib-Assistent das Prozesswissen Ihrer Hausverwaltung: Die Leitlinien gelten bei jedem Entwurf, das Playbook schlägt der Agent bei Bedarf gezielt nach (Abschnitte mit '# TEIL X — Titel' gliedern).",
    "CopyTemplate": "Standard-Playbook kopieren",
    "Form": {
      "GuidelinesSection": "Leitlinien (immer aktiv)",
      "GuidelinesHint": "Kurz halten — dieser Text wird jedem einzelnen Entwurf und Chat mitgegeben. Ideal für: Zuständigkeiten, Eskalationswege, was nie zugesagt werden darf, Grundton der Verwaltung.",
      "Guidelines": "Leitlinien",
      "GuidelinesPlaceholder": "z. B.: Reparaturen bis 300 € beauftragt die Verwaltung direkt. Rechtsfragen niemals selbst beantworten, immer an RA Schmidt verweisen. Zusagen zu Terminen nur nach Rücksprache …",
      "PlaybookSection": "Playbook (auf Abruf)",
      "PlaybookHint": "Das ausführliche Prozesshandbuch — der Agent schlägt einzelne Abschnitte nach, wenn der Fall es braucht. Leer lassen = mitgeliefertes Standard-Playbook. Gliederung mit '# TEIL A — Titel', '# TEIL B — …'.",
      "Playbook": "Playbook",
      "PlaybookPlaceholder": "# TEIL A — Mangelmeldungen\\nBei Wasserschäden sofort …\\n\\n# TEIL B — Eigentümerversammlungen\\n…",
      "AnalysisRulesSection": "Analyse-Regeln",
      "AnalysisRulesHint": "Verbindliche Regeln für die E-Mail-Analyse (Kategorien, \"Antwort nötig\", Aufgaben) — hier korrigierst du Fehlurteile dauerhaft, z.B.: \"Dekra-/TÜV-Prüftermine sind immer Wartung & Prüfung, nie Beschluss & Versammlung.\" Eine Regel pro Zeile.",
      "AnalysisRules": "Analyse-Regeln",
      "AnalysisRulesPlaceholder": "z.B.: ZP-/Prüftermine von Dekra oder TÜV → Kategorie Wartung & Prüfung, keine Antwort nötig.",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Guidelines": "Allgemeine Leitlinien, an die sich der KI-Assistent bei allen Antworten hält.",
        "AnalysisRules": "Regeln, nach denen eingehende E-Mails analysiert und klassifiziert werden.",
        "Playbook": "Ausführliches Playbook mit Abläufen und Beispielen für den KI-Assistenten."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Assistent konfigurieren",
          "Description": "Diese Seite steuert das Verhalten des KI-Assistenten. Der Rundgang erklärt die drei Konfigurationsbereiche."
        },
        "Guidelines": {
          "Title": "Leitlinien",
          "Description": "Allgemeine Vorgaben (Tonfall, Grenzen, Prioritäten), die der Assistent bei allen Antworten beachtet."
        },
        "AnalysisRules": {
          "Title": "Analyse-Regeln",
          "Description": "Regeln für die automatische Analyse eingehender E-Mails — etwa wie Kategorien und Aufgaben abgeleitet werden."
        },
        "Playbook": {
          "Title": "Playbook",
          "Description": "Ausführliche Abläufe und Beispiele. Über „Vorlage kopieren“ lässt sich das mitgelieferte Playbook als Ausgangspunkt einfügen."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern übernimmt die Konfiguration — sie wirkt ab der nächsten Analyse bzw. dem nächsten Antwortentwurf."
        }
      }
    },
    "Toasts": {
      "Updated": "KI-Agent-Konfiguration gespeichert",
      "TemplateCopied": "Standard-Playbook in die Zwischenablage kopiert"
    }
  },
  "MyStyle": {
    "Title": "Mein KI-Schreibstil",
    "Hint": "Dein persönlicher Schreibstil für alle KI-Entwürfe, die du anforderst oder die dir als Zuständigem automatisch erstellt werden — er geht dem Mailbox-Stil bei Widerspruch vor. Beispiele: \"Kurz und direkt, keine Floskeln.\" · \"Anrede: Moin. Schluss: Beste Grüße.\" · \"Nie Passiv, nie Konjunktiv.\"",
    "Placeholder": "z.B.: Kurz und direkt. Keine Floskeln wie \"gerne kommen wir zurück auf\". Du-Anrede nur, wenn die Gegenseite duzt.",
    "Saved": "Schreibstil gespeichert.",
    "Failed": "Schreibstil konnte nicht gespeichert werden."
  },
  "Account": {
    "Account": "Konto",
    "Search for accounts": "Konten suchen",
    "Kinds": {
      "Asset": "Bestand",
      "Closing": "Abschluss",
      "Cost": "Kosten",
      "Debtor": "Debitor",
      "Money": "Geld",
      "Revenue": "Erlös"
    },
    "List": {
      "Filter": {
        "Filter": "Suche",
        "Kinds": "Arten",
        "Name": "Name",
        "Number": "Nummer",
        "PropertyIds": "Objekte"
      },
      "Kind": "Art",
      "Name": "Name",
      "Number": "Nummer",
      "Property": "Objekt",
      "System": "System",
      "TaxKey": "Steuerschlüssel",
      "PageTitle": "Konten",
      "PageSubtitle": "Sachkonten der Objekt-Buchhaltung."
    }
  },
  "Address": {
    "Form": {
      "Title": "Adresse",
      "City": "Stadt",
      "Country": "Land",
      "HouseNumber": "Hausnummer",
      "Street": "Straße",
      "ZipCode": "PLZ",
      "Info": {
        "Street": "Straße der Adresse.",
        "HouseNumber": "Hausnummer, ggf. mit Zusatz (z.B. 12a).",
        "ZipCode": "Postleitzahl der Adresse.",
        "City": "Ort der Adresse.",
        "Country": "Land der Adresse."
      }
    },
    "Countries": {
      "AT": "Österreich",
      "CH": "Schweiz",
      "DE": "Deutschland",
      "FR": "Frankreich",
      "IT": "Italien"
    }
  },
  "An error occurred": {
    "": "Ein Fehler ist aufgetreten."
  },
  "An internal server error occurred": {
    "": "Ein interner Serverfehler ist aufgetreten."
  },
  "AnnualStatement": {
    "Actions": {
      "Build": "Abrechnung erstellen",
      "GobdExport": "GoBD-Export",
      "GobdVerify": "GoBD-Kette prüfen"
    },
    "Title": "Jahresabrechnung",
    "Toasts": {
      "PropertyRequired": "Bitte zuerst ein Objekt wählen."
    },
    "Total": {
      "Checks": "Prüfungen",
      "Expenses": "Ausgaben",
      "Income": "Einnahmen",
      "ReserveClosing": "Rücklage Ende",
      "ReserveOpening": "Rücklage Anfang",
      "Title": "Gesamtabrechnung",
      "ZeroProof": "Nullsummenprobe"
    },
    "Unit": {
      "Account": "Konto",
      "AdvancePayments": "Vorauszahlungen",
      "Amount": "Betrag",
      "Balance": "Saldo",
      "Days": "Tage",
      "DistributionKey": "Verteilerschlüssel",
      "HeatingCost": "Heizkosten",
      "Section35a": "§ 35a",
      "Share": "Anteil",
      "TotalAmount": "Gesamtbetrag",
      "TotalCosts": "Gesamtkosten"
    },
    "Verify": {
      "EntriesChecked": "Geprüfte Einträge",
      "FirstBrokenEntry": "Erster fehlerhafter Eintrag",
      "Title": "GoBD-Prüfung"
    }
  },
  "BankConnection": {
    "Actions": {
      "Create": "Bankverbindung anlegen"
    },
    "Form": {
      "Bank": "Bank",
      "Ebics": "EBICS-Zugang",
      "BankName": "Bank",
      "HostId": "Host-ID",
      "HostUrl": "Host-URL",
      "Mode": "Modus",
      "Name": "Name",
      "PartnerId": "Partner-ID",
      "UserId": "Teilnehmer-ID",
      "CreateTitle": "Bankverbindung anlegen",
      "EditTitle": "Bankverbindung bearbeiten",
      "Subtitle": "Stammdaten und EBICS-Zugangsdaten der Bankverbindung.",
      "BackToList": "Zur Bankverbindungsliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Name": "Interner Anzeigename der Bankverbindung.",
        "BankName": "Name der Bank, z. B. „Sparkasse Musterstadt“.",
        "Mode": "Betriebsmodus der Anbindung — Sandbox zum Testen, sonst der produktive Kanal.",
        "HostUrl": "EBICS-Host-URL der Bank (https://…).",
        "HostId": "EBICS-Host-ID laut Unterlagen der Bank.",
        "PartnerId": "EBICS-Partner-ID (Kunden-ID) laut Unterlagen der Bank.",
        "UserId": "EBICS-Teilnehmer-ID (User-ID) laut Unterlagen der Bank."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Bankverbindung anlegen",
          "Description": "Dieses Formular legt eine neue Bankverbindung an. Die EBICS-Zugangsdaten stehen in den Unterlagen der Bank."
        },
        "Name": {
          "Title": "Name",
          "Description": "Interner Anzeigename der Bankverbindung. Pflichtfeld."
        },
        "BankName": {
          "Title": "Bankname",
          "Description": "Name der Bank, z. B. „Sparkasse Musterstadt“."
        },
        "Mode": {
          "Title": "Modus",
          "Description": "Betriebsmodus der Anbindung — Sandbox zum Testen, sonst der produktive Kanal."
        },
        "HostUrl": {
          "Title": "Host-URL",
          "Description": "EBICS-Host-URL der Bank (https://…)."
        },
        "HostId": {
          "Title": "Host-ID",
          "Description": "EBICS-Host-ID laut Unterlagen der Bank."
        },
        "PartnerId": {
          "Title": "Partner-ID",
          "Description": "EBICS-Partner-ID (Kunden-ID) laut Unterlagen der Bank."
        },
        "UserId": {
          "Title": "Teilnehmer-ID",
          "Description": "EBICS-Teilnehmer-ID (User-ID) laut Unterlagen der Bank."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Bankverbindung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste."
        }
      }
    },
    "Toasts": {
      "AccountsSynced": "Konten synchronisiert.",
      "BankKeysConfirmed": "Bankschlüssel bestätigt.",
      "Created": "Bankverbindung angelegt.",
      "FetchQueued": "Abruf eingeplant.",
      "Initialized": "EBICS initialisiert.",
      "Updated": "Bankverbindung gespeichert."
    },
    "List": {
      "Bank": "Bank",
      "Filter": {
        "Filter": "Suche",
        "Name": "Name",
        "Statuses": "Status"
      },
      "Mode": "Modus",
      "Name": "Name",
      "PartnerId": "Partner-ID",
      "Status": "Status",
      "UserId": "Teilnehmer-ID",
      "PageTitle": "Bankverbindungen",
      "PageSubtitle": "Angebundene Bankkonten für den Umsatzabruf."
    },
    "Modes": {
      "Bridge": "Bridge",
      "Native": "Nativ",
      "Sandbox": "Sandbox",
      "Sdk": "SDK"
    },
    "Statuses": {
      "Active": "Aktiv",
      "BankKeysConfirmed": "Bankschlüssel bestätigt",
      "Created": "Angelegt",
      "Initialized": "Initialisiert"
    }
  },
  "BankTransaction": {
    "Actions": {
      "Import": "Importieren"
    },
    "Import": {
      "Camt": "CAMT-Datei",
      "ImportBatchId": "Import-Batch",
      "Imported": "Importiert",
      "Mt940": "MT940-Datei",
      "Placeholder": "Dateiinhalt einfügen …",
      "Result": "Ergebnis",
      "Skipped": "Übersprungen",
      "Title": "Bankumsätze importieren"
    },
    "Toasts": {
      "Ignored": "Umsatz ignoriert.",
      "Imported": "Umsätze importiert.",
      "MatchingRan": "Zuordnung ausgeführt."
    },
    "List": {
      "Amount": "Betrag",
      "BankAccount": "Bankkonto",
      "BookingDate": "Buchungsdatum",
      "Counterpart": "Gegenpartei",
      "Filter": {
        "CounterpartName": "Gegenpartei",
        "Filter": "Suche",
        "PropertyBankAccountIds": "Bankkonten",
        "Purpose": "Verwendungszweck",
        "Statuses": "Status"
      },
      "Purpose": "Verwendungszweck",
      "Status": "Status",
      "PageTitle": "Umsätze",
      "PageSubtitle": "Importierte Bankumsätze und ihre Zuordnung."
    },
    "Statuses": {
      "Ignored": "Ignoriert",
      "Matched": "Zugeordnet",
      "Suggested": "Vorschlag",
      "Unmatched": "Offen"
    }
  },
  "Booking": {
    "Actions": {
      "Create": "Buchung anlegen"
    },
    "Form": {
      "Accounts": "Konten",
      "Booking": "Buchung",
      "Amount": "Betrag",
      "BookingDate": "Buchungsdatum",
      "CreditAccountId": "Habenkonto",
      "DebitAccountId": "Sollkonto",
      "Description": "Beschreibung",
      "PropertyId": "Objekt",
      "CreateTitle": "Buchung anlegen",
      "EditTitle": "Buchung bearbeiten",
      "Subtitle": "Beschreibung, Datum, Betrag sowie Objekt und Konten der Buchung.",
      "BackToList": "Zur Buchungsliste",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "DebitAccountRequired": "Sollkonto ist erforderlich",
      "CreditAccountRequired": "Habenkonto ist erforderlich",
      "Info": {
        "Description": "Buchungstext, z. B. „Grundsteuer Q3“.",
        "BookingDate": "Datum, unter dem die Buchung geführt wird.",
        "Amount": "Betrag der Buchung in Euro.",
        "Property": "Das Objekt, dem die Buchung zugeordnet wird.",
        "DebitAccount": "Das Konto, das im Soll bebucht wird.",
        "CreditAccount": "Das Konto, das im Haben bebucht wird."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Buchung anlegen",
          "Description": "Dieses Formular legt eine neue Buchung an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Description": {
          "Title": "Beschreibung",
          "Description": "Buchungstext, z. B. „Grundsteuer Q3“. Pflichtfeld."
        },
        "BookingDate": {
          "Title": "Buchungsdatum",
          "Description": "Datum, unter dem die Buchung geführt wird."
        },
        "Amount": {
          "Title": "Betrag",
          "Description": "Betrag der Buchung in Euro."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Das Objekt, dem die Buchung zugeordnet wird. Pflichtfeld."
        },
        "DebitAccount": {
          "Title": "Sollkonto",
          "Description": "Das Konto, das im Soll bebucht wird. Pflichtfeld."
        },
        "CreditAccount": {
          "Title": "Habenkonto",
          "Description": "Das Konto, das im Haben bebucht wird. Pflichtfeld."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Buchung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "Toasts": {
      "Committed": "Buchung festgeschrieben.",
      "Created": "Buchung angelegt.",
      "Reversed": "Buchung storniert.",
      "Updated": "Buchung gespeichert."
    },
    "List": {
      "Amount": "Betrag",
      "BookingDate": "Buchungsdatum",
      "Credit": "Haben",
      "Debit": "Soll",
      "Description": "Beschreibung",
      "EntryNumber": "Belegnummer",
      "Filter": {
        "Description": "Beschreibung",
        "Filter": "Suche",
        "FiscalYear": "Wirtschaftsjahr",
        "PropertyIds": "Objekte",
        "Statuses": "Status"
      },
      "Property": "Objekt",
      "Status": "Status",
      "PageTitle": "Buchungen",
      "PageSubtitle": "Alle Buchungen der Objekte — Entwürfe und festgeschriebene."
    },
    "Statuses": {
      "Draft": "Entwurf",
      "Posted": "Gebucht",
      "Reversed": "Storniert"
    }
  },
  "Branch": {
    "Actions": {
      "Create": "Niederlassung anlegen"
    },
    "Branch": "Niederlassung",
    "Form": {
      "MasterData": "Stammdaten",
      "City": "Stadt",
      "Name": "Name",
      "CreateTitle": "Niederlassung anlegen",
      "EditTitle": "Niederlassung bearbeiten",
      "Subtitle": "Stammdaten der Niederlassung — Name und Stadt.",
      "BackToList": "Zur Niederlassungsliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Name": "Bezeichnung der Niederlassung, z. B. „Hauptsitz Köln“.",
        "City": "Stadt, in der die Niederlassung ansässig ist."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Niederlassung anlegen",
          "Description": "Dieses Formular legt eine Niederlassung an. Der Rundgang führt durch die beiden Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Bezeichnung der Niederlassung, z. B. „Hauptsitz Köln“. Pflichtfeld."
        },
        "City": {
          "Title": "Stadt",
          "Description": "Stadt, in der die Niederlassung ansässig ist. Pflichtfeld."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Niederlassung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste."
        }
      }
    },
    "Search for branches": "Niederlassungen suchen",
    "Toasts": {
      "Created": "Niederlassung angelegt.",
      "Updated": "Niederlassung gespeichert."
    },
    "List": {
      "City": "Stadt",
      "Filter": {
        "City": "Stadt",
        "Filter": "Suche",
        "Name": "Name"
      },
      "Name": "Name",
      "Properties": "Objekte",
      "PageTitle": "Filialen",
      "PageSubtitle": "Niederlassungen der Verwaltung."
    }
  },
  "BudgetPlan": {
    "Actions": {
      "Apply": "Sollstellung anwenden",
      "Approve": "Beschließen",
      "Create": "Wirtschaftsplan anlegen"
    },
    "Detail": {
      "ResolutionId": "Beschluss",
      "Title": "Wirtschaftsplan"
    },
    "Form": {
      "Plan": "Wirtschaftsplan",
      "PropertyId": "Objekt",
      "Year": "Jahr",
      "CreateTitle": "Wirtschaftsplan anlegen",
      "EditTitle": "Wirtschaftsplan bearbeiten",
      "Subtitle": "Objekt und Planjahr des Wirtschaftsplans.",
      "BackToList": "Zur Wirtschaftsplanliste",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "Info": {
        "Property": "Das Objekt, für das der Wirtschaftsplan aufgestellt wird.",
        "Year": "Das Planjahr — üblicherweise das kommende Kalenderjahr."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Wirtschaftsplan anlegen",
          "Description": "Dieses Formular legt einen neuen Wirtschaftsplan an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Das Objekt, für das der Wirtschaftsplan aufgestellt wird. Pflichtfeld."
        },
        "Year": {
          "Title": "Jahr",
          "Description": "Das Planjahr — vorbelegt ist das kommende Kalenderjahr."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt den Wirtschaftsplan an. Die Positionen werden anschließend im Detail gepflegt."
        }
      }
    },
    "List": {
      "ApprovedAt": "Beschlossen am",
      "ReserveAmount": "Rücklage",
      "Status": "Status",
      "TotalAmount": "Gesamtbetrag",
      "Filter": {
        "Filter": "Suche",
        "PropertyIds": "Objekte",
        "Statuses": "Status",
        "Year": "Jahr"
      },
      "Property": "Objekt",
      "Year": "Jahr",
      "PageTitle": "Wirtschaftspläne",
      "PageSubtitle": "Wirtschaftspläne der Objekte."
    },
    "Positions": {
      "Account": "Konto",
      "Amount": "Betrag",
      "PreviousYearActual": "Vorjahr (Ist)",
      "Title": "Positionen"
    },
    "Toasts": {
      "Applied": "Sollstellung angewendet.",
      "Approved": "Wirtschaftsplan beschlossen.",
      "Created": "Wirtschaftsplan angelegt.",
      "ResolutionRequired": "Bitte einen Beschluss angeben.",
      "Updated": "Wirtschaftsplan gespeichert."
    },
    "UnitAmounts": {
      "MonthlyHousingFee": "Hausgeld / Monat",
      "MonthlyReserve": "Rücklage / Monat",
      "Title": "Beträge je Einheit",
      "Unit": "Einheit"
    },
    "Statuses": {
      "Applied": "Angewandt",
      "Approved": "Beschlossen",
      "Draft": "Entwurf"
    }
  },
  "Building": {
    "Actions": {
      "Create": "Gebäude anlegen"
    },
    "Building": "Gebäude",
    "Form": {
      "MasterData": "Stammdaten",
      "ConstructionYear": "Baujahr",
      "HouseNumber": "Hausnummer",
      "Name": "Name",
      "PropertyId": "Objekt",
      "Street": "Straße",
      "CreateTitle": "Gebäude anlegen",
      "EditTitle": "Gebäude bearbeiten",
      "Subtitle": "Stammdaten des Gebäudes — Objekt, Adresse und Baujahr.",
      "BackToList": "Zur Gebäudeliste",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "Info": {
        "Name": "Bezeichnung des Gebäudes, z. B. „Vorderhaus“ oder „Haus A“.",
        "Property": "Das Objekt, zu dem das Gebäude gehört.",
        "ConstructionYear": "Baujahr des Gebäudes — nur ganze Zahlen, z. B. 1985.",
        "Street": "Straße der Gebäudeadresse — falls sie von der Objektadresse abweicht.",
        "HouseNumber": "Hausnummer der Gebäudeadresse."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Gebäude anlegen",
          "Description": "Dieses Formular legt ein neues Gebäude an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Bezeichnung des Gebäudes, z. B. „Vorderhaus“ oder „Haus A“. Pflichtfeld."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Das Objekt, zu dem das Gebäude gehört. Pflichtfeld."
        },
        "ConstructionYear": {
          "Title": "Baujahr",
          "Description": "Baujahr des Gebäudes als ganze Zahl, z. B. 1985."
        },
        "Street": {
          "Title": "Straße",
          "Description": "Straße der Gebäudeadresse — optional, falls abweichend von der Objektadresse."
        },
        "HouseNumber": {
          "Title": "Hausnummer",
          "Description": "Hausnummer der Gebäudeadresse — optional."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt das Gebäude an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        }
      }
    },
    "Search for buildings": "Gebäude suchen",
    "Toasts": {
      "Created": "Gebäude angelegt.",
      "Updated": "Gebäude gespeichert."
    },
    "List": {
      "ConstructionYear": "Baujahr",
      "Filter": {
        "Filter": "Suche",
        "Name": "Name",
        "PropertyIds": "Objekte",
        "ConstructionYear": "Baujahr"
      },
      "Name": "Name",
      "Property": "Objekt",
      "Units": "Einheiten",
      "PageTitle": "Gebäude",
      "PageSubtitle": "Alle Gebäude der verwalteten Objekte."
    }
  },
  "ContactBankAccount": {
    "List": {
      "Bic": "BIC",
      "HolderName": "Kontoinhaber",
      "Iban": "IBAN",
      "Filter": {
        "ContactIds": "Kontakte",
        "Filter": "Suche",
        "Iban": "IBAN"
      }
    }
  },
  "ContactInUnit": {
    "Form": {
      "Connection": "Verknüpfung",
      "Validity": "Gültigkeit",
      "ContactId": "Kontakt",
      "Role": "Rolle",
      "UnitId": "Einheit",
      "ValidFrom": "Gültig ab",
      "ValidTo": "Gültig bis",
      "CreateTitle": "Zuordnung anlegen",
      "EditTitle": "Zuordnung bearbeiten",
      "Subtitle": "Verknüpfung von Kontakt und Einheit — Rolle und Gültigkeitszeitraum.",
      "BackToList": "Zur Einheit",
      "StartTour": "Ausfüllhilfe starten",
      "ContactRequired": "Kontakt ist erforderlich",
      "UnitRequired": "Einheit ist erforderlich",
      "Info": {
        "Contact": "Der Kontakt, der mit der Einheit verknüpft wird.",
        "Unit": "Die Einheit, der der Kontakt zugeordnet wird.",
        "Role": "Rolle des Kontakts in der Einheit: Eigentümer, Mieter oder Dienstleister.",
        "ValidFrom": "Beginn der Zuordnung, z. B. Vertrags- oder Kaufdatum.",
        "ValidTo": "Optional: Ende der Zuordnung — leer bedeutet unbefristet.",
        "Validity": "Zeitraum der Beteiligung — das Ende leer lassen, wenn sie laufend ist."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Zuordnung anlegen",
          "Description": "Dieses Formular verknüpft einen Kontakt mit einer Einheit. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Contact": {
          "Title": "Kontakt",
          "Description": "Der Kontakt, der mit der Einheit verknüpft wird. Pflichtfeld."
        },
        "Unit": {
          "Title": "Einheit",
          "Description": "Die Einheit, der der Kontakt zugeordnet wird. Pflichtfeld."
        },
        "Role": {
          "Title": "Rolle",
          "Description": "Rolle des Kontakts in der Einheit: Eigentümer, Mieter oder Dienstleister."
        },
        "ValidFrom": {
          "Title": "Gültig ab",
          "Description": "Beginn der Zuordnung, z. B. Vertrags- oder Kaufdatum. Pflichtfeld."
        },
        "ValidTo": {
          "Title": "Gültig bis",
          "Description": "Optional: Ende der Zuordnung — leer bedeutet unbefristet."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Zuordnung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick auf einen Fehler springt direkt zum Feld."
        },
        "Validity": {
          "Title": "Gültigkeit",
          "Description": "Von wann bis wann gilt die Beteiligung? Das Ende leer lassen, wenn sie laufend ist."
        }
      },
      "ValidToHint": "Leer = laufend",
      "SearchContact": "Suche nach Kontakt",
      "SearchUnit": "Suche nach Einheit",
      "OwnerCreateTitle": "Eigentümerwechsel",
      "TenantCreateTitle": "Mieterwechsel",
      "OwnerSubtitle": "Neuen Eigentümer mit der Einheit verknüpfen — ab wann und (optional) bis wann.",
      "TenantSubtitle": "Neuen Mieter mit der Einheit verknüpfen — ab wann und (optional) bis wann."
    },
    "List": {
      "Contact": "Kontakt",
      "Role": "Rolle",
      "ValidFrom": "Gültig ab",
      "ValidTo": "Gültig bis",
      "Filter": {
        "ContactIds": "Kontakte",
        "Filter": "Suche",
        "PropertyIds": "Objekte",
        "Roles": "Rollen",
        "UnitIds": "Einheiten"
      },
      "Unit": "Einheit"
    },
    "Toasts": {
      "Created": "Zuordnung angelegt.",
      "Updated": "Zuordnung gespeichert."
    },
    "Roles": {
      "Owner": "Eigentümer",
      "Tenant": "Mieter",
      "Contractor": "Dienstleister"
    }
  },
  "DistributionKey": {
    "Actions": {
      "Create": "Verteilerschlüssel anlegen"
    },
    "Form": {
      "MasterData": "Stammdaten",
      "Basis": "Basis",
      "Name": "Name",
      "PropertyId": "Objekt",
      "UnitLabel": "Einheit (Beschriftung)",
      "CreateTitle": "Verteilerschlüssel anlegen",
      "EditTitle": "Verteilerschlüssel bearbeiten",
      "Subtitle": "Name, Objekt und Verteilungsbasis des Schlüssels.",
      "BackToList": "Zur Verteilerschlüsselliste",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "Info": {
        "Name": "Bezeichnung des Verteilerschlüssels, z. B. „Nach Wohnfläche“.",
        "Property": "Das Objekt, in dem der Schlüssel gilt.",
        "Basis": "Grundlage der Verteilung: MEA, Fläche, Personen, Einheiten, Verbrauch, Heizkosten oder Direktzuordnung.",
        "UnitLabel": "Optionale Beschriftung der Einheit, z. B. „m²“ oder „Personen“."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Verteilerschlüssel anlegen",
          "Description": "Dieses Formular legt einen neuen Verteilerschlüssel an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Bezeichnung des Verteilerschlüssels, z. B. „Nach Wohnfläche“. Pflichtfeld."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Das Objekt, in dem der Schlüssel gilt. Pflichtfeld."
        },
        "Basis": {
          "Title": "Basis",
          "Description": "Grundlage der Verteilung: MEA, Fläche, Personen, Einheiten, Verbrauch, Heizkosten oder Direktzuordnung."
        },
        "UnitLabel": {
          "Title": "Einheit (Beschriftung)",
          "Description": "Optionale Beschriftung der Einheit, z. B. „m²“ oder „Personen“."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt den Verteilerschlüssel an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste."
        }
      }
    },
    "Toasts": {
      "Created": "Verteilerschlüssel angelegt.",
      "Updated": "Verteilerschlüssel gespeichert."
    },
    "Bases": {
      "Area": "Fläche",
      "Consumption": "Verbrauch",
      "Direct": "Direktzuordnung",
      "HeatingCost": "Heizkosten",
      "Persons": "Personen",
      "Shares": "Miteigentumsanteile",
      "Units": "Einheiten"
    },
    "List": {
      "Basis": "Basis",
      "Filter": {
        "Filter": "Suche",
        "Name": "Name",
        "PropertyIds": "Objekte"
      },
      "Name": "Name",
      "Property": "Objekt",
      "System": "System",
      "UnitLabel": "Einheit (Beschriftung)",
      "PageTitle": "Verteilerschlüssel",
      "PageSubtitle": "Verteilerschlüssel und Mengenerfassung der Objekte."
    }
  },
  "File": {
    "Errors": {
      "Required": "Bitte eine Datei wählen.",
      "Size": "Die Datei ist zu groß.",
      "Type": "Dieser Dateityp wird nicht unterstützt.",
      "Unknown": "Die Datei konnte nicht verarbeitet werden."
    }
  },
  "FiscalYear": {
    "Toasts": {
      "Closed": "Wirtschaftsjahr abgeschlossen."
    },
    "List": {
      "EndsAt": "Ende",
      "Filter": {
        "Filter": "Suche",
        "PropertyIds": "Objekte",
        "Statuses": "Status"
      },
      "Property": "Objekt",
      "StartsAt": "Beginn",
      "Status": "Status",
      "Year": "Jahr",
      "PageTitle": "Wirtschaftsjahre",
      "PageSubtitle": "Wirtschaftsjahre der verwalteten Objekte."
    },
    "Statuses": {
      "Closed": "Abgeschlossen",
      "Open": "Offen"
    }
  },
  "General": {
    "There are no available": "Keine Einträge vorhanden",
    "You are not allowed to view this page": {
      " Please ask your administrator for permissions to view this page": "Sie dürfen diese Seite nicht sehen. Bitte wenden Sie sich an Ihren Administrator."
    },
    "date": {
      "at": "um"
    },
    "days ago": "Tagen",
    "hours ago": "Stunden",
    "just now": "gerade eben"
  },
  "Inspection": {
    "Actions": {
      "AddItem": "Feststellung hinzufügen",
      "Create": "Begehung anlegen",
      "Lock": "Abschließen"
    },
    "Form": {
      "Inspection": "Begehung",
      "InspectorName": "Begeher",
      "PropertyId": "Objekt",
      "ScheduledAt": "Termin",
      "Title": "Titel",
      "CreateTitle": "Begehung anlegen",
      "EditTitle": "Begehung bearbeiten",
      "Subtitle": "Eckdaten der Begehung — Objekt, Titel, Termin und begehende Person.",
      "BackToList": "Zur Begehungsliste",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "Info": {
        "Property": "Das Objekt, das begangen wird.",
        "Title": "Bezeichnung der Begehung, z. B. „Frühjahrsbegehung 2026“.",
        "ScheduledAt": "Datum, an dem die Begehung stattfindet.",
        "InspectorName": "Name der Person, die die Begehung durchführt."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Begehung anlegen",
          "Description": "Dieses Formular legt eine Begehung an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Das Objekt, das begangen wird. Pflichtfeld."
        },
        "Title": {
          "Title": "Titel",
          "Description": "Bezeichnung der Begehung, z. B. „Frühjahrsbegehung 2026“. Pflichtfeld."
        },
        "ScheduledAt": {
          "Title": "Termin",
          "Description": "Datum, an dem die Begehung stattfindet."
        },
        "InspectorName": {
          "Title": "Begehende Person",
          "Description": "Name der Person, die die Begehung vor Ort durchführt."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Begehung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick springt direkt zum Feld."
        }
      }
    },
    "Items": {
      "Category": "Kategorie",
      "Description": "Beschreibung",
      "Severity": "Schwere",
      "Title": "Feststellungen",
      "Unit": "Einheit"
    },
    "List": {
      "Inspector": "Begeher",
      "ScheduledAt": "Termin",
      "Status": "Status",
      "Filter": {
        "Filter": "Suche",
        "PropertyIds": "Objekte",
        "Statuses": "Status",
        "Title": "Titel"
      },
      "Property": "Objekt",
      "Title": "Titel",
      "PageTitle": "Begehungen",
      "PageSubtitle": "Begehungen und Prüfungen der Objekte."
    },
    "Severities": {
      "ActionRequired": "Handlungsbedarf",
      "Defect": "Mangel",
      "Ok": "In Ordnung"
    },
    "Toasts": {
      "Created": "Begehung angelegt.",
      "ItemAdded": "Feststellung hinzugefügt.",
      "Locked": "Begehung abgeschlossen.",
      "Updated": "Begehung gespeichert."
    },
    "Statuses": {
      "Locked": "Abgeschlossen",
      "Performed": "Durchgeführt",
      "Planned": "Geplant"
    }
  },
  "Match": {
    "Actions": {
      "Run": "Zuordnung ausführen"
    },
    "Run": {
      "ImportBatchId": "Import-Batch",
      "UseLlm": "KI-Unterstützung nutzen"
    },
    "Toasts": {
      "Confirmed": "Zuordnung bestätigt.",
      "Ran": "Zuordnung ausgeführt.",
      "Rejected": "Zuordnung verworfen."
    },
    "List": {
      "Amount": "Betrag",
      "Confidence": "Konfidenz",
      "Counterpart": "Gegenpartei",
      "Filter": {
        "CounterpartName": "Gegenpartei",
        "Filter": "Suche",
        "PropertyBankAccountIds": "Bankkonten",
        "Statuses": "Status"
      },
      "Purpose": "Verwendungszweck",
      "Reason": "Begründung",
      "Status": "Status",
      "SuggestedAccount": "Vorgeschlagenes Konto",
      "Unit": "Einheit",
      "PageTitle": "Matching",
      "PageSubtitle": "Zuordnung von Bankumsätzen zu offenen Posten."
    },
    "Statuses": {
      "Confirmed": "Bestätigt",
      "Rejected": "Abgelehnt",
      "Suggested": "Vorschlag"
    }
  },
  "MatchingRule": {
    "Actions": {
      "Create": "Zuordnungsregel anlegen"
    },
    "Form": {
      "Matcher": "Erkennung",
      "Rule": "Regel",
      "AccountId": "Konto",
      "MatcherType": "Matcher",
      "Name": "Name",
      "Pattern": "Muster",
      "PropertyId": "Objekt",
      "Scope": "Geltungsbereich",
      "CreateTitle": "Zuordnungsregel anlegen",
      "EditTitle": "Zuordnungsregel bearbeiten",
      "Subtitle": "Regel für die automatische Zuordnung von Bankumsätzen zu Konten.",
      "BackToList": "Zur Regelliste",
      "StartTour": "Ausfüllhilfe starten",
      "AccountRequired": "Konto ist erforderlich",
      "Info": {
        "Name": "Bezeichnung der Regel, z. B. „Stadtwerke Abschlag“.",
        "Scope": "Gilt die Regel mandantenweit oder nur für ein Objekt?",
        "Property": "Nur bei Objekt-Regeln: das Objekt, auf das die Regel beschränkt ist.",
        "MatcherType": "Worauf die Regel prüft: ein Stichwort im Verwendungszweck oder eine IBAN.",
        "Pattern": "Das Stichwort bzw. die IBAN, auf die geprüft wird.",
        "Account": "Das Konto, das die Regel bei einem Treffer vorschlägt."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Zuordnungsregel anlegen",
          "Description": "Diese Regel schlägt bei passenden Bankumsätzen automatisch ein Konto vor — gebucht wird erst nach Bestätigung. Der Rundgang führt durch alle Felder."
        },
        "Name": {
          "Title": "Name",
          "Description": "Bezeichnung der Regel, z. B. „Stadtwerke Abschlag“. Pflichtfeld."
        },
        "Scope": {
          "Title": "Geltungsbereich",
          "Description": "Mandantenweit gilt die Regel für alle Umsätze; bei „Objekt“ nur für Umsätze des gewählten Objekts."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Nur bei Objekt-Regeln relevant: das Objekt, auf das die Regel beschränkt ist."
        },
        "MatcherType": {
          "Title": "Prüfkriterium",
          "Description": "Stichwort prüft den Verwendungszweck, IBAN die Gegenseite des Umsatzes."
        },
        "Pattern": {
          "Title": "Muster",
          "Description": "Das Stichwort bzw. die IBAN, auf die geprüft wird. Pflichtfeld."
        },
        "Account": {
          "Title": "Konto",
          "Description": "Das Konto, das bei einem Treffer als Buchungsvorschlag gesetzt wird. Pflichtfeld."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Regel an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick springt direkt zum Feld."
        }
      }
    },
    "Toasts": {
      "Created": "Zuordnungsregel angelegt.",
      "StatusChanged": "Status geändert.",
      "Updated": "Zuordnungsregel gespeichert."
    },
    "List": {
      "Account": "Konto",
      "Filter": {
        "Filter": "Suche",
        "Name": "Name",
        "PropertyIds": "Objekte",
        "Statuses": "Status"
      },
      "MatcherType": "Matcher",
      "Name": "Name",
      "Pattern": "Muster",
      "Property": "Objekt",
      "Scope": "Geltungsbereich",
      "Status": "Status",
      "Version": "Version",
      "PageTitle": "Matching-Regeln",
      "PageSubtitle": "Regeln für die automatische Umsatz-Zuordnung."
    },
    "Matchers": {
      "Iban": "IBAN",
      "Keyword": "Stichwort"
    },
    "Scopes": {
      "Property": "Objekt",
      "Tenant": "Mandant"
    },
    "Statuses": {
      "Disabled": "Deaktiviert",
      "Enabled": "Aktiv"
    }
  },
  "Meeting": {
    "Actions": {
      "AddResolution": "Beschluss hinzufügen",
      "Create": "Versammlung anlegen",
      "Lock": "Protokoll abschließen",
      "RecordAttendance": "Anwesenheit erfassen",
      "SendInvitations": "Einladungen versenden"
    },
    "AttendanceStates": {
      "Absent": "Abwesend",
      "Present": "Anwesend",
      "Represented": "Vertreten"
    },
    "Attendances": {
      "Contact": "Kontakt",
      "RepresentedBy": "Vertreten durch",
      "State": "Status",
      "Title": "Anwesenheit",
      "VotingShare": "Stimmanteil"
    },
    "Detail": {
      "LockedHint": "Die Versammlung ist abgeschlossen — Änderungen sind nicht mehr möglich."
    },
    "Form": {
      "Meeting": "Versammlung",
      "Location": "Ort",
      "PropertyId": "Objekt",
      "ScheduledAt": "Termin",
      "Title": "Titel",
      "CreateTitle": "Versammlung anlegen",
      "EditTitle": "Versammlung bearbeiten",
      "Subtitle": "Eckdaten der Versammlung — Objekt, Titel, Termin und Ort.",
      "BackToList": "Zur Versammlungsliste",
      "StartTour": "Ausfüllhilfe starten",
      "PropertyRequired": "Objekt ist erforderlich",
      "Info": {
        "Property": "Das Objekt, für das die Versammlung stattfindet.",
        "Title": "Bezeichnung der Versammlung, z. B. „Eigentümerversammlung 2026“.",
        "ScheduledAt": "Datum, an dem die Versammlung stattfindet.",
        "Location": "Ort bzw. Adresse, an dem die Versammlung abgehalten wird."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Versammlung anlegen",
          "Description": "Dieses Formular legt eine Versammlung an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Property": {
          "Title": "Objekt",
          "Description": "Das Objekt, für das die Versammlung stattfindet. Pflichtfeld."
        },
        "Title": {
          "Title": "Titel",
          "Description": "Bezeichnung der Versammlung, z. B. „Eigentümerversammlung 2026“. Pflichtfeld."
        },
        "ScheduledAt": {
          "Title": "Termin",
          "Description": "Datum, an dem die Versammlung stattfindet."
        },
        "Location": {
          "Title": "Ort",
          "Description": "Ort bzw. Adresse, an dem die Versammlung abgehalten wird."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Versammlung an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste — ein Klick springt direkt zum Feld."
        }
      }
    },
    "Invitations": {
      "Contact": "Kontakt",
      "SentAt": "Versendet am",
      "Title": "Einladungen"
    },
    "List": {
      "Location": "Ort",
      "ScheduledAt": "Termin",
      "Status": "Status",
      "Filter": {
        "Filter": "Suche",
        "PropertyIds": "Objekte",
        "Statuses": "Status",
        "Title": "Titel"
      },
      "Property": "Objekt",
      "Title": "Titel",
      "PageTitle": "Versammlungen",
      "PageSubtitle": "Eigentümerversammlungen der Objekte."
    },
    "Resolutions": {
      "Result": "Ergebnis",
      "TextPlaceholder": "Beschlusstext …",
      "Title": "Beschlüsse",
      "TitlePlaceholder": "Titel des Beschlusses …"
    },
    "Toasts": {
      "AttendanceRecorded": "Anwesenheit erfasst.",
      "Created": "Versammlung angelegt.",
      "InvitationsSent": "Einladungen versendet.",
      "Locked": "Protokoll abgeschlossen.",
      "ResolutionAdded": "Beschluss hinzugefügt.",
      "Updated": "Versammlung gespeichert.",
      "VoteContactRequired": "Bitte zuerst einen Kontakt wählen.",
      "Voted": "Stimme erfasst."
    },
    "Votes": {
      "Abstention": "Enthaltung",
      "No": "Nein",
      "Yes": "Ja"
    },
    "Statuses": {
      "Created": "Angelegt",
      "InProgress": "Läuft",
      "Invited": "Eingeladen",
      "Locked": "Abgeschlossen"
    }
  },
  "Notification": {
    "Actions": {
      "Create": "Mitteilung anlegen",
      "Schedule": "Einplanen"
    },
    "Form": {
      "Audience": "Empfängerkreis",
      "Delivery": "Zustellung",
      "Message": "Nachricht",
      "RespectChannelMute": "Stummschaltungen respektieren",
      "Body": "Inhalt",
      "Channel": "Kanal",
      "ChannelId": "Kanal-Ziel",
      "Roles": "Rollen",
      "ScheduledAt": "Termin",
      "Title": "Titel",
      "CreateTitle": "Mitteilung anlegen",
      "EditTitle": "Mitteilung bearbeiten",
      "Subtitle": "Inhalt, Empfängerkreis und Zustellung der Mitteilung.",
      "BackToList": "Zur Mitteilungsliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Title": "Überschrift der Mitteilung, wie sie den Empfängern angezeigt wird.",
        "Body": "Inhalt der Mitteilung — Formatierungen werden übernommen.",
        "Channel": "Zustellweg: Dashboard, E-Mail oder beides (Multi).",
        "ScheduledAt": "Optionaler Versandzeitpunkt — leer bedeutet sofortiger Versand.",
        "Properties": "Empfänger auf Kontakte dieser Objekte eingrenzen.",
        "Buildings": "Empfänger auf Kontakte dieser Gebäude eingrenzen.",
        "Units": "Empfänger auf Kontakte dieser Einheiten eingrenzen.",
        "Roles": "Empfänger auf diese Rollen eingrenzen, z. B. nur Eigentümer.",
        "IncludingContacts": "Diese Kontakte zusätzlich in den Empfängerkreis aufnehmen.",
        "ExcludingContacts": "Diese Kontakte vom Empfängerkreis ausschließen.",
        "ChannelId": "Optionales Kanal-Ziel, dem die Mitteilung zugeordnet wird.",
        "RespectChannelMute": "Wenn aktiv, erhalten Empfänger mit stummgeschaltetem Kanal die Mitteilung nicht."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Mitteilung anlegen",
          "Description": "Dieses Formular erstellt eine Mitteilung an Plattform-Nutzer. Der Rundgang führt durch Inhalt, Empfängerkreis und Zustellung."
        },
        "Title": {
          "Title": "Titel",
          "Description": "Überschrift der Mitteilung, wie sie den Empfängern angezeigt wird. Pflichtfeld."
        },
        "Channel": {
          "Title": "Kanal",
          "Description": "Zustellweg der Mitteilung: Dashboard, E-Mail oder beides (Multi)."
        },
        "Body": {
          "Title": "Inhalt",
          "Description": "Der eigentliche Text der Mitteilung — Formatierungen werden übernommen. Pflichtfeld."
        },
        "ScheduledAt": {
          "Title": "Versandzeitpunkt",
          "Description": "Optional: die Mitteilung erst zu diesem Zeitpunkt versenden. Leer bedeutet sofortiger Versand."
        },
        "Properties": {
          "Title": "Objekte",
          "Description": "Grenzt den Empfängerkreis auf Kontakte der gewählten Objekte ein."
        },
        "Buildings": {
          "Title": "Gebäude",
          "Description": "Grenzt den Empfängerkreis auf Kontakte der gewählten Gebäude ein."
        },
        "Units": {
          "Title": "Einheiten",
          "Description": "Grenzt den Empfängerkreis auf Kontakte der gewählten Einheiten ein."
        },
        "Roles": {
          "Title": "Rollen",
          "Description": "Grenzt den Empfängerkreis auf die gewählten Rollen ein, z. B. nur Eigentümer."
        },
        "IncludingContacts": {
          "Title": "Zusätzliche Kontakte",
          "Description": "Diese Kontakte erhalten die Mitteilung in jedem Fall zusätzlich."
        },
        "ExcludingContacts": {
          "Title": "Ausgeschlossene Kontakte",
          "Description": "Diese Kontakte werden vom Empfängerkreis ausgenommen."
        },
        "ChannelId": {
          "Title": "Kanal-Ziel",
          "Description": "Optionales Ziel, dem die Mitteilung zugeordnet wird."
        },
        "RespectChannelMute": {
          "Title": "Stummschaltungen",
          "Description": "Wenn aktiv, wird die Mitteilung Empfängern mit stummgeschaltetem Kanal nicht zugestellt."
        },
        "Actions": {
          "Title": "Senden",
          "Description": "Speichern legt die Mitteilung an und versendet sie sofort bzw. zum gewählten Zeitpunkt. Fehler erscheinen unten in der Liste — ein Klick springt direkt zum Feld."
        }
      }
    },
    "List": {
      "Channel": "Kanal",
      "Recipients": "Empfänger",
      "ScheduledAt": "Geplant für",
      "Status": "Status",
      "Filter": {
        "Filter": "Suche",
        "Statuses": "Status",
        "Title": "Titel"
      },
      "Title": "Titel",
      "PageTitle": "Benachrichtigungen",
      "PageSubtitle": "Benachrichtigungen an die Nutzer der Plattform."
    },
    "Toasts": {
      "Created": "Mitteilung angelegt.",
      "Deleted": "Mitteilung gelöscht.",
      "Scheduled": "Mitteilung eingeplant.",
      "Updated": "Mitteilung gespeichert."
    },
    "Channels": {
      "Dashboard": "Dashboard",
      "Email": "E-Mail",
      "Multi": "Mehrere Kanäle"
    },
    "Statuses": {
      "Draft": "Entwurf",
      "Scheduled": "Geplant",
      "Sent": "Versendet"
    }
  },
  "NotificationRecipient": {
    "DeliveryLog": "Zustellprotokoll",
    "List": {
      "Channel": "Kanal",
      "Name": "Name",
      "Read": "Gelesen",
      "SendAt": "Senden am",
      "SentAt": "Gesendet am",
      "Email": "E-Mail",
      "Filter": {
        "Channels": "Kanäle",
        "Filter": "Suche",
        "NotificationIds": "Benachrichtigungen"
      }
    }
  },
  "Object": {
    "Search for objects": "Objekte suchen"
  },
  "PaymentBatch": {
    "Actions": {
      "Approve": "Freigeben",
      "HausgeldRun": "Hausgeld-Lauf",
      "ImportPain002": "pain.002 importieren",
      "Submit": "Einreichen"
    },
    "Approvals": {
      "At": "Am",
      "Title": "Freigaben",
      "User": "Benutzer"
    },
    "Detail": {
      "Title": "Zahlungslauf"
    },
    "Instructions": {
      "Amount": "Betrag",
      "Counterpart": "Empfänger",
      "Iban": "IBAN",
      "Purpose": "Verwendungszweck",
      "Title": "Zahlungen"
    },
    "List": {
      "ExecutionDate": "Ausführung",
      "Status": "Status",
      "TotalAmount": "Gesamtbetrag",
      "Type": "Art",
      "BankAccount": "Bankkonto",
      "Filter": {
        "Filter": "Suche",
        "PropertyBankAccountIds": "Bankkonten",
        "Statuses": "Status"
      },
      "Instructions": "Aufträge",
      "Property": "Objekt",
      "PageTitle": "Zahlläufe",
      "PageSubtitle": "SEPA-Zahlläufe der Objekte."
    },
    "Pain002": {
      "Placeholder": "pain.002-Inhalt einfügen …",
      "Title": "Statusrückmeldung importieren"
    },
    "Run": {
      "Period": "Periode"
    },
    "Toasts": {
      "Approved": "Zahlungslauf freigegeben.",
      "HausgeldRun": "Hausgeld-Lauf erstellt.",
      "Pain002Imported": "Statusrückmeldung importiert.",
      "Submitted": "Zahlungslauf eingereicht."
    },
    "Statuses": {
      "Accepted": "Akzeptiert",
      "Approved": "Freigegeben",
      "Created": "Angelegt",
      "Rejected": "Abgelehnt",
      "Submitted": "Eingereicht"
    }
  },
  "Permission": {
    "Actions": {
      "AddMember": "Mitglied hinzufügen",
      "EditGroup": "Gruppe bearbeiten",
      "Lookup": "Prüfen"
    },
    "Catalog": {
      "Hint": "Alle bekannten Berechtigungen des Systems.",
      "Title": "Katalog"
    },
    "Direct": {
      "Denies": "Verbote",
      "Grants": "Erlaubnisse",
      "Hint": "Direkte Zuweisungen gehen Gruppen vor.",
      "Title": "Direkte Berechtigungen"
    },
    "Effective": {
      "Title": "Effektive Berechtigungen"
    },
    "Groups": {
      "Name": "Name",
      "Title": "Gruppen",
      "UserId": "Benutzer"
    },
    "Title": "Berechtigungen",
    "Toasts": {
      "DirectSaved": "Berechtigungen gespeichert.",
      "MemberAdded": "Mitglied hinzugefügt.",
      "MemberRemoved": "Mitglied entfernt."
    }
  },
  "PlatformInvite": {
    "Actions": {
      "Create": "Einladung anlegen"
    },
    "Form": {
      "Invite": "Einladung",
      "ContactId": "Kontakt",
      "Email": "E-Mail",
      "Role": "Rolle",
      "CreateTitle": "Einladung anlegen",
      "EditTitle": "Einladung bearbeiten",
      "Subtitle": "E-Mail, Rolle und optional der verknüpfte Kontakt der Einladung.",
      "BackToList": "Zur Nutzerliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Email": "E-Mail-Adresse, an die die Einladung verschickt wird.",
        "Role": "Rolle, die der eingeladene Nutzer auf der Plattform erhält.",
        "Contact": "Optional: der Kontakt, mit dem der neue Nutzer verknüpft wird."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Einladung anlegen",
          "Description": "Dieses Formular lädt einen neuen Nutzer auf die Plattform ein. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Email": {
          "Title": "E-Mail",
          "Description": "E-Mail-Adresse, an die die Einladung verschickt wird. Pflichtfeld."
        },
        "Role": {
          "Title": "Rolle",
          "Description": "Rolle, die der eingeladene Nutzer auf der Plattform erhält."
        },
        "Contact": {
          "Title": "Kontakt",
          "Description": "Optional: der Kontakt, mit dem der neue Nutzer verknüpft wird."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern verschickt die Einladung. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste."
        }
      }
    },
    "Toasts": {
      "Created": "Einladung angelegt.",
      "Resent": "Einladung erneut versendet.",
      "Revoked": "Einladung zurückgezogen.",
      "Updated": "Einladung gespeichert."
    },
    "List": {
      "Contact": "Kontakt",
      "Email": "E-Mail",
      "ExpiresAt": "Läuft ab",
      "Filter": {
        "Email": "E-Mail",
        "Filter": "Suche",
        "Statuses": "Status"
      },
      "Role": "Rolle",
      "Status": "Status"
    },
    "Statuses": {
      "Accepted": "Angenommen",
      "Pending": "Ausstehend",
      "Revoked": "Widerrufen"
    }
  },
  "PlatformUser": {
    "Toasts": {
      "Revoked": "Zugang entzogen."
    },
    "List": {
      "Contact": "Kontakt",
      "Email": "E-Mail",
      "Filter": {
        "Email": "E-Mail",
        "Filter": "Suche",
        "Roles": "Rollen",
        "Statuses": "Status"
      },
      "Name": "Name",
      "Role": "Rolle",
      "Status": "Status",
      "PageTitle": "Benutzer",
      "PageSubtitle": "Benutzer der Plattform und offene Einladungen."
    },
    "Roles": {
      "Administrator": "Administrator",
      "Employee": "Mitarbeiter",
      "Owner": "Eigentümer",
      "ServiceProvider": "Dienstleister",
      "Tenant": "Mieter"
    },
    "Statuses": {
      "Active": "Aktiv",
      "Revoked": "Widerrufen"
    }
  },
  "PropertyBankAccount": {
    "BankAccount": "Bankkonto",
    "Search for bank accounts": "Bankkonten suchen",
    "List": {
      "Balance": "Saldo",
      "Filter": {
        "Filter": "Suche",
        "Iban": "IBAN",
        "PropertyIds": "Objekte"
      },
      "Iban": "IBAN",
      "LedgerAccount": "Sachkonto",
      "Name": "Name",
      "Property": "Objekt"
    }
  },
  "Search": {
    "Actions": {
      "Reindex": "Neu indizieren",
      "Search": "Suchen"
    },
    "Fuzzy": "Unscharfe Suche",
    "NoResults": "Keine Treffer.",
    "Placeholder": "Suchbegriff …",
    "Title": "Suche",
    "Toasts": {
      "ReindexQueued": "Neuindizierung eingeplant."
    },
    "EntityTypes": {
      "Property": "Objekte",
      "Unit": "Einheiten",
      "Contact": "Kontakte",
      "Contractor": "Dienstleister",
      "Document": "Dokumente",
      "Email": "E-Mails",
      "Task": "Aufgaben"
    }
  },
  "SepaMandate": {
    "Actions": {
      "Create": "SEPA-Mandat anlegen"
    },
    "Form": {
      "Mandate": "Mandat",
      "ContactId": "Kontakt",
      "Iban": "IBAN",
      "Reference": "Mandatsreferenz",
      "SignedAt": "Unterschrieben am",
      "CreateTitle": "SEPA-Mandat anlegen",
      "EditTitle": "SEPA-Mandat bearbeiten",
      "Subtitle": "Mandatsreferenz, Kontakt, IBAN und Unterschriftsdatum.",
      "BackToList": "Zur Mandatsliste",
      "StartTour": "Ausfüllhilfe starten",
      "ContactRequired": "Kontakt ist erforderlich",
      "Info": {
        "Reference": "Eindeutige Mandatsreferenz — erscheint auf dem Kontoauszug des Zahlers.",
        "Contact": "Der Kontakt (Zahler), der das Mandat erteilt hat.",
        "Iban": "IBAN des Kontos, von dem eingezogen wird.",
        "SignedAt": "Datum, an dem das Mandat unterschrieben wurde."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "SEPA-Mandat anlegen",
          "Description": "Dieses Formular legt ein neues SEPA-Lastschriftmandat an. Der Rundgang führt Schritt für Schritt durch alle Felder."
        },
        "Reference": {
          "Title": "Mandatsreferenz",
          "Description": "Eindeutige Referenz des Mandats — erscheint auf dem Kontoauszug des Zahlers. Pflichtfeld."
        },
        "Contact": {
          "Title": "Kontakt",
          "Description": "Der Kontakt (Zahler), der das Mandat erteilt hat. Pflichtfeld."
        },
        "Iban": {
          "Title": "IBAN",
          "Description": "IBAN des Kontos, von dem eingezogen wird."
        },
        "SignedAt": {
          "Title": "Unterschrieben am",
          "Description": "Datum, an dem das Mandat unterschrieben wurde."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt das Mandat an. Pflichtfelder werden geprüft; Fehler erscheinen unten in der Liste."
        }
      }
    },
    "Toasts": {
      "Created": "SEPA-Mandat angelegt.",
      "Updated": "SEPA-Mandat gespeichert."
    },
    "List": {
      "Contact": "Kontakt",
      "Filter": {
        "ContactIds": "Kontakte",
        "Filter": "Suche",
        "Reference": "Mandatsreferenz",
        "Statuses": "Status"
      },
      "Iban": "IBAN",
      "Reference": "Mandatsreferenz",
      "SequenceType": "Sequenz",
      "SignedAt": "Unterschrieben am",
      "Status": "Status",
      "PageTitle": "SEPA-Mandate",
      "PageSubtitle": "Lastschriftmandate der Kontakte."
    },
    "Statuses": {
      "Active": "Aktiv",
      "Revoked": "Widerrufen"
    }
  },
  "Setting": {
    "Key": "Schlüssel",
    "Scopes": {
      "Tenant": "Verwaltung",
      "User": "Benutzer"
    },
    "Title": "Einstellungen",
    "Toasts": {
      "Saved": "Einstellung gespeichert."
    },
    "Value": "Wert"
  },
  "Sollstellung": {
    "Actions": {
      "Run": "Sollstellung ausführen"
    },
    "Hint": "Erzeugt die monatlichen Forderungen aus dem beschlossenen Wirtschaftsplan.",
    "Runs": {
      "Entries": "Einträge",
      "ExecutedAt": "Ausgeführt am",
      "ExecutedBy": "Ausgeführt von",
      "Period": "Periode",
      "Property": "Objekt",
      "Title": "Läufe"
    },
    "Title": "Sollstellung",
    "Toasts": {
      "PropertyAndPeriodRequired": "Bitte Objekt und Periode wählen.",
      "Ran": "Sollstellung ausgeführt."
    }
  },
  "TenantDomain": {
    "Actions": {
      "Create": "Domain anlegen",
      "Verify": "Prüfen"
    },
    "Dns": {
      "Hint": "Diese DNS-Einträge bei Ihrem Domain-Anbieter hinterlegen.",
      "Title": "DNS-Einträge",
      "Type": "Typ",
      "Valid": "Gültig",
      "Value": "Wert"
    },
    "Form": {
      "Domain": "Domain",
      "Hostname": "Hostname",
      "CreateTitle": "Domain anlegen",
      "EditTitle": "Domain bearbeiten",
      "Subtitle": "Eigene Domain des Mandanten — nach dem Anlegen erscheinen die zu setzenden DNS-Einträge.",
      "BackToList": "Zur Domainliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Hostname": "Vollständiger Hostname, z. B. „portal.meine-hausverwaltung.de“ — ohne https:// und ohne Pfad."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Domain anlegen",
          "Description": "Dieses Formular verbindet eine eigene Domain mit der Plattform. Nach dem Anlegen zeigt die Detailseite die zu setzenden CNAME-/TXT-Einträge."
        },
        "Hostname": {
          "Title": "Hostname",
          "Description": "Vollständiger Hostname, z. B. „portal.meine-hausverwaltung.de“ — ohne https:// und ohne Pfad. Pflichtfeld."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt die Domain an und öffnet die Detailseite mit den DNS-Einträgen zur Verifizierung."
        }
      }
    },
    "List": {
      "Status": "Status",
      "CnameTarget": "CNAME-Ziel",
      "CnameValid": "CNAME gültig",
      "Filter": {
        "Filter": "Suche",
        "Hostname": "Hostname",
        "Statuses": "Status"
      },
      "Hostname": "Hostname",
      "TxtValid": "TXT gültig",
      "PageTitle": "Domains",
      "PageSubtitle": "E-Mail-Domains des Mandanten."
    },
    "Toasts": {
      "Created": "Domain angelegt.",
      "Verified": "Domain verifiziert."
    },
    "Statuses": {
      "Pending": "Ausstehend",
      "Verified": "Verifiziert"
    }
  },
  "The request is invalid": {
    "": "Die Anfrage ist ungültig."
  },
  "The requested resource could not be found": {
    "": "Die angeforderte Ressource wurde nicht gefunden."
  },
  "The server is not reachable": {
    "": "Der Server ist nicht erreichbar."
  },
  "Webhook": {
    "Actions": {
      "CopySecret": "Secret kopieren",
      "Create": "Webhook anlegen",
      "Done": "Fertig",
      "Retry": "Erneut zustellen"
    },
    "Deliveries": {
      "Attempts": "Versuche",
      "DeliveredAt": "Zugestellt am",
      "Event": "Ereignis",
      "Status": "Status",
      "StatusCode": "HTTP-Status",
      "Title": "Zustellungen"
    },
    "Detail": {
      "SecretHint": "Das Secret signiert jede Zustellung (HMAC)."
    },
    "Form": {
      "Receiver": "Empfänger",
      "Events": "Ereignisse",
      "Name": "Name",
      "Url": "URL",
      "CreateTitle": "Webhook anlegen",
      "EditTitle": "Webhook bearbeiten",
      "Subtitle": "Empfänger-URL und Ereignisse — das Signatur-Secret erscheint nach dem Anlegen genau einmal.",
      "BackToList": "Zur Webhookliste",
      "StartTour": "Ausfüllhilfe starten",
      "Info": {
        "Name": "Interner Anzeigename des Webhooks.",
        "Url": "HTTPS-Endpunkt, an den die Ereignisse zugestellt werden.",
        "Events": "Ereignistypen, die zugestellt werden — mindestens einer."
      },
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Webhook anlegen",
          "Description": "Dieses Formular legt einen neuen Webhook an. Nach dem Anlegen erscheint das Signatur-Secret genau einmal — direkt kopieren!"
        },
        "Name": {
          "Title": "Name",
          "Description": "Interner Anzeigename des Webhooks. Pflichtfeld."
        },
        "Url": {
          "Title": "URL",
          "Description": "HTTPS-Endpunkt, an den die Ereignisse zugestellt werden. Pflichtfeld."
        },
        "Events": {
          "Title": "Ereignisse",
          "Description": "Ereignistypen, die zugestellt werden — mindestens einer."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichern legt den Webhook an und zeigt einmalig das Signatur-Secret zum Kopieren."
        }
      }
    },
    "List": {
      "Events": "Ereignisse",
      "Status": "Status",
      "Url": "URL",
      "Filter": {
        "Filter": "Suche",
        "Name": "Name",
        "Statuses": "Status"
      },
      "Name": "Name",
      "PageTitle": "Webhooks",
      "PageSubtitle": "Webhook-Abonnements für externe Systeme."
    },
    "Secret": {
      "OnceHint": "Das Secret wird nur einmal angezeigt — jetzt kopieren.",
      "Title": "Webhook-Secret"
    },
    "Toasts": {
      "Created": "Webhook angelegt.",
      "DeliveryRetried": "Zustellung erneut angestoßen.",
      "SecretCopied": "Secret kopiert.",
      "Updated": "Webhook gespeichert."
    },
    "Statuses": {
      "Disabled": "Deaktiviert",
      "Enabled": "Aktiv"
    },
    "DeliveryStatuses": {
      "Pending": "Ausstehend",
      "Succeeded": "Erfolgreich",
      "Failed": "Fehlgeschlagen"
    }
  },
  "You are not allowed to perform this action": {
    "": "Sie dürfen diese Aktion nicht ausführen."
  },
  "You are not authorized to perform this action": {
    "": "Sie sind für diese Aktion nicht autorisiert."
  },
  "AgentRules": {
    "Title": "KI-Regeln",
    "Hint": "Strukturierte Wenn-Dann-Regeln — greifen deterministisch vor der KI-Analyse; die semantische Bedingung wandert in den Analyse-Prompt. Spezifischere Geltung (Kontakt > Postfach > Objekt > Organisation) gewinnt.",
    "Add": "Regel anlegen",
    "AddCondition": "+ Bedingung",
    "Empty": "Noch keine Regeln — die erste Regel ist in einer Minute angelegt.",
    "Trust": "Vertrauen",
    "Used": "angewandt",
    "LetAiDecide": "KI entscheidet",
    "Scopes": {
      "Organization": "Organisation",
      "Property": "Objekt",
      "Mailbox": "Postfach",
      "Contact": "Kontakt"
    },
    "ConditionFields": {
      "fromAddress": "Absender-Adresse",
      "fromDomain": "Absender-Domain",
      "subject": "Betreff",
      "body": "Text",
      "toAddress": "Empfänger"
    },
    "Operators": {
      "contains": "enthält",
      "equals": "ist genau",
      "startsWith": "beginnt mit",
      "endsWith": "endet mit",
      "regex": "Regex"
    },
    "Fields": {
      "Title": "Titel",
      "Scope": "Geltung",
      "ScopeId": "Geltungs-Id",
      "Conditions": "Bedingungen (alle müssen zutreffen)",
      "Semantic": "Semantische Bedingung (optional, KI-geprüft)",
      "SemanticPlaceholder": "z.B. „Die Mail meldet einen Wasserschaden\"",
      "Category": "Kategorie setzen",
      "Assignee": "Zuständig setzen",
      "NeedsReply": "Antwort nötig",
      "SkipAnalysis": "KI-Analyse überspringen"
    },
    "Toasts": {
      "Saved": "Regel gespeichert",
      "Failed": "Speichern fehlgeschlagen",
      "Incomplete": "Titel und mindestens eine Bedingung mit Wert angeben"
    },
    "Proposal": "Vorschlag",
    "Activate": "Aktivieren",
    "Statuses": {
      "Active": "Aktiv",
      "Inactive": "Deaktiviert",
      "Draft": "Vorschlag"
    },
    "Deactivate": "Deaktivieren"
  },
  "AccountDistributionConfiguration": {
    "List": {
      "Account": "Konto",
      "Apportionable": "Umlagefähig",
      "DistributionKey": "Verteilerschlüssel",
      "Filter": {
        "AccountIds": "Konten",
        "Filter": "Suche",
        "FiscalYear": "Wirtschaftsjahr"
      },
      "FiscalYear": "Wirtschaftsjahr",
      "InBudgetPlan": "Im Wirtschaftsplan",
      "InStatement": "In der Abrechnung"
    }
  },
  "Actions": {
    "Cancel": "Abbrechen",
    "Delete": "Löschen",
    "Edit": "Bearbeiten",
    "Save": "Speichern"
  },
  "DistributionKeyQuantity": {
    "List": {
      "DistributionKey": "Verteilerschlüssel",
      "Filter": {
        "DistributionKeyIds": "Verteilerschlüssel",
        "Filter": "Suche",
        "UnitIds": "Einheiten",
        "Year": "Jahr"
      },
      "Quantity": "Menge",
      "Unit": "Einheit",
      "Year": "Jahr"
    }
  },
  "PropertyContractor": {
    "Form": {
      "CreateTitle": "Dienstleister verknüpfen",
      "Subtitle": "Wer macht welches Gewerk in diesem Objekt — ab wann und wie lange.",
      "BackToProperty": "Zum Objekt",
      "StartTour": "Tour starten",
      "ContractorId": "Dienstleister",
      "ContractorRequired": "Bitte einen Dienstleister auswählen.",
      "Validity": "Gültigkeit",
      "Tour": {
        "Next": "Weiter",
        "Prev": "Zurück",
        "Done": "Fertig",
        "Intro": {
          "Title": "Dienstleister verknüpfen",
          "Description": "Hier verbindest du einen Dienstleister mit dem Objekt — mit Gewerk und Gültigkeitszeitraum."
        },
        "Contractor": {
          "Title": "Dienstleister",
          "Description": "Welche Firma ist zuständig? Tippe zum Suchen."
        },
        "Unit": {
          "Title": "Einheit (optional)",
          "Description": "Nur angeben, wenn die Zuordnung für eine einzelne Einheit gilt statt für das ganze Objekt."
        },
        "Trade": {
          "Title": "Gewerk",
          "Description": "Wofür ist der Dienstleister zuständig — z.B. Sanitär, Elektro, Garten."
        },
        "Validity": {
          "Title": "Gültigkeit",
          "Description": "Ab wann gilt die Zuordnung? Das Ende leer lassen, wenn sie laufend ist."
        },
        "Notes": {
          "Title": "Notizen",
          "Description": "Optionale Hinweise, z.B. Konditionen oder Ansprechpartner."
        },
        "Actions": {
          "Title": "Speichern",
          "Description": "Speichert die Zuordnung und kehrt zum Objekt zurück."
        }
      },
      "Info": {
        "Validity": "Zeitraum der Zuordnung — das Ende leer lassen, wenn sie laufend ist."
      }
    },
    "Toasts": {
      "Created": "Dienstleister wurde mit dem Objekt verknüpft."
    }
  },
  "ContractorAssignment": {
    "List": {
      "Filter": {
        "Filter": "Suche",
        "Trade": "Gewerk",
        "ContractorName": "Dienstleister"
      }
    }
  },
  "TenantWorkflows": {
    "Title": "Workflows",
    "Hint": "Eigene Automatisierungen als Flussdiagramm: WENN ein Ereignis eintritt (E-Mail, Dokument, Aufgabe, Zeitpunkt), DANN laufen Schritte — inkl. Verzweigungen, parallelen Zweigen und Wartezeiten.",
    "Add": "Workflow anlegen",
    "Empty": "Noch keine Workflows — mit „Workflow anlegen\" die erste Automatisierung bauen.",
    "Executed": "ausgeführt",
    "Runs": "Verlauf",
    "NoRuns": "Noch keine Ausführungen.",
    "Activate": "Aktivieren",
    "Deactivate": "Deaktivieren",
    "When": "Wenn",
    "Then": "Dann",
    "TriggerEmailAnalyzed": "Auslöser: Eine E-Mail wurde analysiert (Kategorie, Zuordnung und Zusammenfassung liegen vor). Alle Bedingungen müssen zutreffen — ohne Bedingungen läuft der Workflow auf jeder Mail.",
    "AddCondition": "+ Bedingung",
    "AddAction": "+ Aktion",
    "EveryMail": "jede E-Mail",
    "Yes": "Ja",
    "No": "Nein",
    "PlaceholderHint": "Platzhalter: {{subject}}, {{fromName}}, {{fromAddress}}, {{category}}, {{property}}, {{unit}}, {{contact}}, {{contractor}}, {{body}}, {{receivedAt}}, {{summary}}, {{documentTitle}}, {{documentType}}, {{taskTitle}}, {{taskStatus}} sowie {{var:name}} für Variablen.",
    "Statuses": {
      "Active": "Aktiv",
      "Inactive": "Deaktiviert",
      "Waiting": "Wartet",
      "Draft": "Entwurf"
    },
    "Operators": {
      "contains": "enthält",
      "equals": "ist gleich",
      "startsWith": "beginnt mit",
      "endsWith": "endet mit",
      "regex": "Regex"
    },
    "Fields": {
      "Name": "Name",
      "Description": "Beschreibung",
      "fromAddress": "Absender-Adresse",
      "fromDomain": "Absender-Domain",
      "subject": "Betreff",
      "body": "Text",
      "category": "Kategorie",
      "needsReply": "Antwort nötig",
      "hasAttachments": "Hat Anhänge",
      "TaskTitle": "Titel der Aufgabe",
      "TaskNote": "Beschreibung der Aufgabe",
      "Priority": "Priorität",
      "DueInDays": "Fällig in Tagen",
      "Assignee": "Zuständig",
      "AsSuggestion": "Als Vorschlag an der E-Mail (nicht direkt aufs Board)",
      "FollowUpNote": "Notiz der Wiedervorlage",
      "Label": "Label",
      "To": "Empfänger (leer = Absender)",
      "ToPlaceholder": "z. B. {{fromAddress}} oder buchhaltung@…",
      "EmailBody": "Antworttext",
      "Method": "Methode",
      "Url": "URL",
      "HttpBody": "JSON-Body",
      "Property": "Objekt",
      "VariableName": "Variablenname",
      "VariableValue": "Wert",
      "LogText": "Log-Text",
      "variable": "Variable",
      "VariablePlaceholder": "z. B. kontakt.count",
      "DelayMinutes": "Wartezeit in Minuten",
      "Query": "Suchtext (Platzhalter möglich)",
      "ResultVariable": "Ergebnis-Variable (Präfix)",
      "Trigger": "Auslöser",
      "documentType": "Dokumenttyp",
      "documentTitle": "Dokumenttitel",
      "documentFileName": "Dateiname",
      "taskTitle": "Aufgabentitel",
      "taskStatus": "Aufgabenstatus",
      "taskPriority": "Aufgabenpriorität",
      "PropertyIdTemplate": "Oder Objekt-ID aus Variable",
      "FieldPlaceholder": "Feld wählen …",
      "path": "Eigener Pfad",
      "PathPlaceholder": "z. B. email.property.name"
    },
    "Actions": {
      "CreateTask": "Aufgabe erstellen",
      "CreateFollowUp": "Wiedervorlage anlegen",
      "SetAssignee": "Zuständigkeit setzen",
      "AddLabel": "Label vergeben",
      "SendEmailReply": "Antwort senden (Postausgang)",
      "SendHttpRequest": "HTTP-Request senden",
      "SetCategory": "Kategorie setzen",
      "SetNeedsReply": "Antwort nötig setzen",
      "MarkAsRead": "Als gelesen markieren",
      "LinkProperty": "Objekt verknüpfen",
      "SetVariable": "Variable setzen",
      "Log": "Log-Eintrag",
      "Stop": "Workflow beenden",
      "If": "Wenn / Dann / Sonst",
      "Parallel": "Parallele Zweige",
      "Wait": "Warten",
      "FindProperty": "Objekt suchen",
      "FindUnit": "Einheit suchen",
      "FindContact": "Kontakt suchen",
      "FindContractor": "Dienstleister suchen",
      "SetTaskStatus": "Aufgabenstatus setzen",
      "SetTaskAssignee": "Aufgabe zuweisen"
    },
    "Toasts": {
      "Saved": "Workflow gespeichert.",
      "Failed": "Speichern fehlgeschlagen.",
      "Incomplete": "Name und mindestens eine Aktion sind erforderlich.",
      "DraftSaved": "Entwurf gespeichert — die laufende Version bleibt unverändert.",
      "Published": "Workflow veröffentlicht.",
      "Restored": "Version in den Entwurf übernommen — „Veröffentlichen\" macht sie live."
    },
    "Else": "Sonst",
    "AddBranch": "+ Zweig",
    "SendEmailHint": "Die Antwort landet im Postausgang und wartet dort 5 Minuten — bis dahin stornierbar. Leerer Empfänger = Antwort an den Absender.",
    "ParallelHint": "Alle Zweige werden ausgeführt; erst wenn alle fertig sind, geht es nach dem Schritt weiter (Join).",
    "StopHint": "Beendet den Workflow — alle folgenden Schritte werden übersprungen.",
    "PropertyLinked": "Objekt ist gewählt — Auswahl unten ersetzt es.",
    "Steps": {
      "CreateTask": "Aufgabe erstellen",
      "CreateFollowUp": "Wiedervorlage anlegen",
      "SetAssignee": "Zuständigkeit setzen",
      "AddLabel": "Label vergeben",
      "SendEmailReply": "Antwort senden (Postausgang)",
      "SendHttpRequest": "HTTP-Request senden",
      "SetCategory": "Kategorie setzen",
      "SetNeedsReply": "Antwort nötig setzen",
      "MarkAsRead": "Als gelesen markieren",
      "LinkProperty": "Objekt verknüpfen",
      "SetVariable": "Variable setzen",
      "Log": "Log-Eintrag",
      "Stop": "Workflow beenden",
      "If": "Wenn / Dann / Sonst",
      "Parallel": "Parallele Zweige",
      "Wait": "Warten",
      "FindProperty": "Objekt suchen",
      "FindUnit": "Einheit suchen",
      "FindContact": "Kontakt suchen",
      "FindContractor": "Dienstleister suchen",
      "SetTaskStatus": "Aufgabenstatus setzen",
      "SetTaskAssignee": "Aufgabe zuweisen"
    },
    "Groups": {
      "Actions": "Aktionen",
      "Data": "Daten",
      "Flow": "Ablauf"
    },
    "WaitHint": "Der Workflow pausiert hier und wird automatisch fortgesetzt — nur auf oberster Ebene möglich.",
    "WaitingUntil": "wartet bis",
    "FindPropertyVars": "Ergebnis: {{var:objekt.id}}, {{var:objekt.name}}, {{var:objekt.number}}, {{var:objekt.count}} (Name des Variablen-Präfix oben wählbar).",
    "FindUnitVars": "Ergebnis: {{var:einheit.id}}, {{var:einheit.name}}, {{var:einheit.number}}, {{var:einheit.propertyId}}, {{var:einheit.count}}.",
    "FindContactVars": "Ergebnis: {{var:kontakt.id}}, {{var:kontakt.name}}, {{var:kontakt.email}}, {{var:kontakt.count}}.",
    "FindContractorVars": "Ergebnis: {{var:dienstleister.id}}, {{var:dienstleister.name}}, {{var:dienstleister.email}}, {{var:dienstleister.count}}.",
    "SelectNode": "Einen Knoten im Diagramm anklicken, um ihn zu bearbeiten — „+\" fügt einen Schritt hinzu.",
    "ConditionsHint": "Bedingungen (alle müssen zutreffen — ohne Bedingungen läuft der Workflow bei jedem Ereignis):",
    "IfHint": "Die Dann/Sonst-Zweige werden im Diagramm unter dem Knoten bearbeitet — „+\" im jeweiligen Zweig fügt Schritte hinzu.",
    "TaskActionHint": "Wirkt auf die AUSLÖSENDE Aufgabe — nur bei Aufgaben-Auslösern sinnvoll.",
    "TriggerGroups": {
      "Email": "E-Mail",
      "Documents": "Dokumente",
      "Tasks": "Aufgaben",
      "Outbound": "Postausgang"
    },
    "Subjects": {
      "Email": "E-Mail",
      "Document": "Dokument",
      "Task": "Aufgabe"
    },
    "Triggers": {
      "EmailAnalyzed": "E-Mail analysiert",
      "EmailFollowUpDue": "Wiedervorlage fällig",
      "DocumentCreated": "Dokument eingegangen (Pipeline)",
      "DocumentUploaded": "Dokument hochgeladen",
      "TaskCreated": "Aufgabe erstellt",
      "TaskStatusChanged": "Aufgabenstatus geändert",
      "TaskAssigneeChanged": "Aufgabe neu zugewiesen",
      "TaskCommentAdded": "Kommentar an Aufgabe",
      "TaskDue": "Aufgabe heute fällig",
      "TaskOverdue": "Aufgabe überfällig",
      "OutboundSent": "Antwort versendet",
      "OutboundFailed": "Antwort-Versand fehlgeschlagen"
    },
    "TriggersHint": "Mehrere Auslöser möglich — der Workflow läuft bei JEDEM davon (Oder-Verknüpfung), jeweils auf dem auslösenden Datensatz.",
    "Produces": "Erzeugt Daten",
    "AvailableData": "Verfügbare Daten an dieser Stelle",
    "SearchesIn": "Durchsucht:",
    "Fit": "Einpassen",
    "ResetPosition": "Position zurücksetzen (Auto-Layout)",
    "ModeAll": "UND",
    "ModeAny": "ODER",
    "InsertData": "Daten einfügen",
    "SearchData": "Daten suchen …",
    "Transforms": "Umwandlungen (in Reihenfolge angewendet)",
    "Insert": "Einfügen",
    "InputData": "Eingangsdaten",
    "ResultData": "Ergebnisdaten",
    "VariableGroup": "Variablen",
    "TransformNames": {
      "upper": "GROSSBUCHSTABEN",
      "lower": "kleinbuchstaben",
      "trim": "Leerzeichen entfernen",
      "firstLine": "Erste Zeile",
      "truncate50": "Kürzen (50)",
      "truncate100": "Kürzen (100)",
      "truncate500": "Kürzen (500)"
    },
    "Placeholders": {
      "subject": "Betreff",
      "fromName": "Absendername",
      "fromAddress": "Absenderadresse",
      "category": "Kategorie",
      "property": "Objekt",
      "unit": "Einheit",
      "contact": "Kontakt",
      "contractor": "Dienstleister",
      "body": "E-Mail-Text",
      "receivedAt": "Empfangsdatum",
      "summary": "KI-Zusammenfassung",
      "documentTitle": "Dokumenttitel",
      "documentType": "Dokumenttyp",
      "taskTitle": "Aufgabentitel",
      "taskStatus": "Aufgabenstatus"
    },
    "DraftPending": "Entwurf geändert",
    "Publish": "Veröffentlichen",
    "DiscardDraft": "Entwurf verwerfen",
    "Versions": "Versionen",
    "Live": "Live",
    "Restore": "Wiederherstellen",
    "SaveDraft": "Entwurf speichern",
    "SaveAndPublish": "Speichern & Veröffentlichen",
    "ParallelBranchHint": "Alle Zweige mit erfüllter (oder leerer) Bedingung laufen; erst wenn alle fertig sind, geht es weiter (Join). Zweig-Bedingungen prüfen die Auslöser-Daten.",
    "AdvancedGroup": "Erweitert",
    "HttpHeaders": "Header",
    "AddHeader": "+ Header",
    "PathSyntaxHint": "Pfad-Syntax für ALLE Eigenschaften: {{email.<pfad>}}, {{task.<pfad>}}, {{document.<pfad>}} — z. B. {{email.property.name}}, {{task.dueOn}}, {{document.metadata.<schlüssel>}}. Funktioniert in Texten UND als Bedingungsfeld (\"Eigener Pfad\")."
  },
  "RecurringTasks": {
    "Title": "Wiederkehrende Aufgaben",
    "New": "Neue Serie",
    "Save": "Speichern",
    "Delete": "Löschen",
    "ConfirmDelete": "Serie „{{title}}“ löschen? Bereits erstellte Aufgaben bleiben erhalten.",
    "Empty": "Noch keine Serien — z. B. monatliche Ablesung oder quartalsweise Wartung anlegen.",
    "Active": "Aktiv",
    "Paused": "Pausiert",
    "NextOccurrence": "Nächster Termin",
    "Toasts": {
      "Saved": "Serie gespeichert"
    },
    "Cadences": {
      "Daily": "Täglich",
      "Weekly": "Wöchentlich",
      "Monthly": "Monatlich",
      "Quarterly": "Quartalsweise",
      "Yearly": "Jährlich"
    },
    "Weekdays": {
      "1": "Montag",
      "2": "Dienstag",
      "3": "Mittwoch",
      "4": "Donnerstag",
      "5": "Freitag",
      "6": "Samstag",
      "7": "Sonntag"
    },
    "Fields": {
      "Title": "Titel",
      "Description": "Beschreibung",
      "Priority": "Priorität",
      "Cadence": "Rhythmus",
      "DayOfWeek": "Wochentag",
      "DayOfMonth": "Tag im Monat",
      "MonthOfYear": "Monat",
      "DueInDays": "Fällig nach (Tagen)",
      "StartOn": "Erster Termin",
      "IsActive": "Aktiv",
      "Assignees": "Zuständige"
    }
  },
  "UserNotifications": {
    "Types": {
      "TaskAssigned": "Zuweisung",
      "TaskMentioned": "Erwähnung",
      "TaskCommented": "Kommentar",
      "TaskDueToday": "Fälligkeit"
    }
  },
  "DmsGovernance": {
    "Title": "DMS-Governance",
    "Override": "Angepasst",
    "Edit": "Bearbeiten",
    "Save": "Speichern",
    "Cancel": "Abbrechen",
    "Reset": "Zurücksetzen",
    "Delete": "Löschen",
    "Toasts": {
      "Saved": "Gespeichert"
    },
    "Retention": {
      "Title": "Aufbewahrungsfristen (Anhang C)",
      "Hint": "Fristen je Dokumenttyp — die Kassations-Kandidaten rechnen mit diesen Werten. Anpassungen gelten mandantenweit; Zurücksetzen stellt den gesetzlichen Standard wieder her.",
      "Type": "Dokumenttyp",
      "Years": "Frist",
      "YearsSuffix": "Jahre",
      "Permanent": "dauerhaft",
      "LegalBasis": "Rechtsgrundlage"
    },
    "RecordPlan": {
      "Title": "Aktenplan (Soll-Dokumente)",
      "Hint": "Welche Dokumenttypen je Objekt bzw. je Einheit vorliegen müssen — die eAkte auf dem Objekt-Detail prüft dagegen.",
      "Empty": "Noch keine Regeln definiert.",
      "Add": "Regel hinzufügen",
      "LabelPlaceholder": "Anzeigename (z. B. Mietvertrag)",
      "Activate": "Aktivieren",
      "Deactivate": "Deaktivieren",
      "ConfirmDelete": "Regel „{{label}}“ löschen?",
      "Scopes": {
        "Property": "je Objekt",
        "Unit": "je Einheit"
      }
    },
    "Schemas": {
      "Title": "Metadaten-Schemata",
      "Hint": "Typisierte Pflicht- und Optionalfelder je Dokumenttyp. Typverletzungen werden bei der Kuration abgewiesen; fehlende Pflichtfelder erscheinen als Hinweis am Dokument.",
      "Fields": "Felder",
      "KeyPlaceholder": "schlüssel (lowerCamel)",
      "LabelPlaceholder": "Anzeigename",
      "Required": "Pflicht",
      "AddField": "Feld hinzufügen",
      "Kinds": {
        "Text": "Text",
        "Number": "Zahl",
        "Date": "Datum",
        "Currency": "Betrag",
        "Iban": "IBAN"
      }
    }
  }
}
